import { TranslationKey } from './fr';

const translationZhCn: Record<TranslationKey, string> = {
    'metadata.description': 'Innovorder 后台管理系统',
    'cookies.banner.message':
        '本网站使用 Cookie 以提升您的使用体验。继续浏览即表示您同意使用这些 Cookie。如需了解更多隐私政策信息或管理您的 Cookie 偏好，请访问我们的专属页面。',
    'cookies.banner.accept': '接受',
    'cookies.banner.decline': '拒绝',
    'legend.DELIVERY': '外卖配送',
    'legend.DRIVE': '得来速',
    'legend.SIT_IN': '堂食',
    'legend.TAKE_AWAY': '自取',
    'legend.KIOSK': '自助终端',
    'legend.WEB': '在线点餐',
    'legend.RECEPTION': '前台',
    'legend.POS': '收银台',
    'legend.LOYALTY': '会员积分',
    'legend.EWALLET_KIOSK': '电子钱包终端',
    'legend.VENDING_MACHINE': '自动售货机',
    'analyticsPage.needBrandSelection': '由于您是管理员，请至少选择一个品牌。',
    'analyticsPage.notAuthorizedToSeeBrand': '您无权查看此品牌。',
    'analyticsPage.cannotMixEducationAndNonEducationBrands': '您不能同时选择团餐品牌和商业餐饮品牌。',
    'analyticsPage.reload': '刷新数据',
    'beta_banner.message': '👋 这是一个 <b>测试版</b>，后续将带来大量改进和修复。',
    'analytics.metabaseError': '发生错误，请稍后重试。',
    'analytics.noAdmin': '很遗憾，IO Analytics 暂不支持管理员模式……请放心，即将上线！',
    'analytics.realTime': '实时数据',
    'analytics.ranking': '排行榜',
    'analytics.products': '产品',
    'analytics.sales': '销售额',
    'analytics.salesSummary': '财务汇总',
    'analytics.demoStaging': '演示（预发布环境）',
    'analytics.attendance': '客流量',
    'analytics.billing': '账单',
    'analytics.dashboard': 'Metabase 仪表盘',
    'analytics.filter.restaurant': '按餐厅筛选',
    'analytics.filter.group': '按分组筛选',
    'analytics.filter.consumption': '消费模式',
    'analytics.filter.channel': '渠道',
    'analytics.filter.HT': '不含税',
    'analytics.filter.TTC': '含税',
    'analytics.filter.takeAway': '自取',
    'analytics.filter.sitIn': '堂食',
    'analytics.filter.delivery': '外卖配送',
    'analytics.filter.drive': '得来速',
    'analytics.filter.kiosk': '自助终端',
    'analytics.filter.web': '在线点餐',
    'analytics.filter.pos': '收银台',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': '自动售货',
    'leaderboard.title': '餐厅排行榜',
    'leaderboard.ranking': '排名',
    'leaderboard.restaurantName': '餐厅',
    'leaderboard.revenue': '营业额',
    'leaderboard.averageBasket': '客单价',
    'leaderboard.ordersCount': '订单数',
    'leaderboard.RestaurantSearchPlaceholder': '搜索餐厅',
    'tile.genericErrorMessage': '发生错误！',
    'tile.errorHint': '请刷新数据',
    'random.or': '或',
    'tooltip.example.label': '示例：',
    'iopay.configuration.title': 'Adyen 配置',
    'iopay.commissions.online.title': '线上佣金',
    'iopay.commissions.proximity.title': '近场佣金',
    'iopay.form.name': '标签',
    'iopay.form.placeholder.name': '标签',
    'iopay.form.accountHolder': '账户持有人标识符',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': '资金账户标识符',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': '商家标识符',
    'iopay.form.placeholder.storeId': '商家标识符',
    'iopay.form.transferInstrumentId': '转账工具标识符',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': '固定佣金金额（欧分）',
    'iopay.form.fixProximityCommissionAmount': '固定佣金金额（欧分）',
    'iopay.form.placeholder.fixOnlineCommissionAmount': '固定佣金金额（欧分）',
    'iopay.form.placeholder.fixProximityCommissionAmount': '固定佣金金额（欧分）',
    'iopay.form.variableOnlineCommissionPercent': '浮动佣金百分比',
    'iopay.form.variableProximityCommissionPercent': '浮动佣金百分比',
    'iopay.form.placeholder.variableOnlineCommissionPercent': '浮动佣金百分比',
    'iopay.form.placeholder.variableProximityCommissionPercent': '浮动佣金百分比',
    'edenred.configuration.title': 'Edenred 模块配置',
    'edenred.form.description': '请填写必要信息以完成 Edenred 集成配置。保存后，餐厅的 Merchant ID 将自动获取。',
    'edenred.form.warning.toSend': '信息已保存，在发送至 Edenred 前仍可修改。',
    'edenred.form.warning.sent': '正在由 Edenred 处理中。',
    'edenred.form.mid': 'Merchant ID',
    'edenred.form.name': '餐厅名称',
    'edenred.form.placeholder.name': '我的餐厅名称',
    'edenred.form.siret': 'SIRET 号码',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': '地址',
    'edenred.form.placeholder.address': '5 avenue Anatole France',
    'edenred.form.zipCode': '邮政编码',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': '城市',
    'edenred.form.placeholder.city': 'Paris',
    'paygreen.configuration.title': '餐厅凭证模块配置',
    'paygreen.form.description': '通过上方提供的表单创建账户后，您将收到公钥和私钥，用于完成模块配置。',
    'paygreen.form.ongoing_v3_migration': 'Paygreen 版本迁移正在准备中，您无需在后台进行任何操作',
    'paygreen.form.enablePaygreenV3': '启用 Paygreen V3',
    'paygreen.form.label': '集成名称',
    'paygreen.form.publicKey': 'V2 公钥（shopId）',
    'paygreen.form.privateKey': 'V2 私钥（token）',
    'paygreen.form.secretKey': 'V3 密钥',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.subShopId': 'V3 子商店 ID（仅在 marketplace 模式下填写）',
    'paygreen.form.supportsLuncheon': '支持 Pass Restaurant（Sodexo）或 Chèque Déjeuner（Up）付款',
    'paygreen.form.supportsSwile': '支持 Swile（原 Lunchr）付款',
    'paygreen.form.supportsRestoflash': '支持 Resto Flash 付款',
    'paygreen.form.placeholder.enablePaygreenV3': '启用 Paygreen V3',
    'paygreen.form.placeholder.label': '集成名称',
    'paygreen.form.placeholder.publicKey': 'V2 公钥（shopId）',
    'paygreen.form.placeholder.privateKey': 'V2 私钥（token）',
    'paygreen.form.placeholder.secretKey': 'V3 密钥',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 子商店 ID（仅在 marketplace 模式下填写）',
    'paygreen.form.placeholder.supportsLuncheon': '支持 Pass Restaurant（Sodexo）或 Chèque Déjeuner（Up）付款',
    'paygreen.form.placeholder.supportsSwile': '支持 Swile（原 Lunchr）付款',
    'paygreen.form.placeholder.supportsRestoflash': '支持 Resto Flash 付款',
    'ubereats.title': 'UberEats 设置',
    'ubereats.description.firstpart':
        '请通过填写您餐厅 UberEats 界面中的 UUID 参考来配置 UberEats 集成。如果您不知道在哪里找到此信息：',
    'ubereats.description.secondpart': '如何查找我餐厅的 Store ID？',
    'ubereats.description.thirdpart': '配置完成后，您的收银机将自动在配送栏目中接收 UberEats 订单。',
    'ubereats.storid': '门店 ID',
    'ubereats.activestorids': '已激活的 Store ID',
    'deliverect.title': 'Deliverect 模块配置',
    'deliverect.subtitle': '如何配置与 Deliverect 的集成？',
    'deliverect.description.firstpart': '请先联系客户经理，以便在 Deliverect 环境中创建账户。',
    'deliverect.description.secondpart': '账户激活后，即可在此界面直接选择需要开启订单推送的渠道。',
    'deliverect.description.thirdpart': '您还可以在该界面进行产品目录同步。',
    'deliverect.contact': '联系客户经理',
    'deliveroo.title': 'Deliveroo 模块配置',
    'deliveroo.subtitle': '如何配置与 Deliveroo 的集成？',
    'deliveroo.description.firstpart': '请先联系客户经理，以便在 Deliveroo 环境中创建账户。',
    'deliveroo.description.secondpart': '账户配置完成后，您的收银机将自动在配送栏目中接收 Deliveroo 订单。',
    'deliveroo.description.thirdpart': '您还可以通过 Deliveroo 界面进行产品目录同步。',
    'deliveroo.contact': '联系客户经理',
    'crous.title': 'CROUS 目录同步模块配置',
    'crous.description': '请选择您希望导入目录的餐厅，并输入客户提供的 CROUS 收银台编号（pos_id）',
    'crous.listcrousrestaurants.label': 'CROUS 餐厅',
    'crous.listcrousrestaurants.placeholder': '选择餐厅',
    'crous.numerocaisse.label': 'CROUS 收银台编号',
    'crous.numerocaisse.placeholder': '请输入 CROUS 收银台编号',
    'crous.apikey.label': 'CROUS API 密钥',
    'crous.apikey.placeholder': '请输入 CROUS API 密钥',
    'marketplace.vatdefault.placeholder': '默认税率（%）',
    'marketplace.vatdefault.message': '默认税率',
    'marketplace.storid.label': '您的门店 ID：',
    'marketplace.storid.placeholder': '输入一个或多个门店 ID',
    'marketplace.storid.unknown': '未知门店 ID',
    'marketplace.storid.alreadyused': '此 UUID 已存在（{name}）',
    'marketplace.activestorids.label': '已激活的虚拟品牌：',
    'marketplace.activestorids.emptystate': '您暂无已激活的虚拟品牌',
    'marketplace.location.title': '品牌 {counter}',
    'marketplace.location.delete': '删除',
    'status.status': '状态',
    'status.active': '已激活',
    'status.inactive': '已停用',
    'status.disabled': '不可用',
    'status.loading': '加载中',
    'status.unknown': '未知',
    'status.new': '新建',
    'status.file_uploaded': '文件已上传',
    'status.processing': '处理中',
    'status.done': '已完成',
    'status.error': '错误',
    'date.created': '创建日期',
    'date.updated': '更新日期',
    'external_pos.pos_ref.label': 'Deliverect POS ID：',
    'external_pos.pos_ref.placeholder': '请输入您的 Deliverect POS ID',
    'external_pos.title': 'Deliverect 外部 POS 配置',
    'external_pos.subtitle': '如何配置我的 Deliverect 外部 POS？',
    'external_pos.description.firstpart': '请先联系客户经理，以便在 Deliverect 环境中创建账户。',
    'external_pos.description.secondpart':
        'Deliverect 外部 POS 配置完成后，将自动接收通过 Innovorder 已激活渠道下单的订单。',
    'external_pos.description.thirdpart': '使用此集成时，我们建议通过 Deliverect 管理并同步菜单。',
    'external_pos.contact': '联系客户经理',
    'external_pos.channels.title': 'Deliverect 外部 POS 集成：',
    'external_pos.channels.subtitle': '已激活渠道：',
    'webhook_url.label': 'Webhook URL',
    'webhook_url.placeholder': 'Webhook URL',
    'webhook_secret.label': 'Webhook 密钥',
    'webhook_secret.placeholder': '请输入 Webhook 密钥',
    'webhook.headers.label': '附加 HTTP 头',
    'webhook.headers.name.placeholder': '头名称',
    'webhook.headers.value.placeholder': '头值',
    'webhook.channels.title': 'Webhook 触发渠道',
    'webhook.channels.subtitle': '可用渠道：',
    'webhook.title': 'Webhook 配置',
    'webhook.firstpart.subtitle': '此 Webhook 的用途',
    'webhook.firstpart.description':
        '此 Webhook 用于通知您的某位顾客在 Innovorder 上提交了订单。\n如果一笔销售是由通过徽章识别的顾客产生的，则会向此 Webhook 发送调用，以推送该订单的相关信息。',
    'webhook.secondpart.subtitle': '如何配置 Webhook？',
    'webhook.secondpart.description':
        '请填写 Webhook URL。\nWebhook 密钥将自动生成。\n点击相应渠道即可为此 Webhook 启用。\n配置完成后，服务必须返回 HTTP 200 状态码及空响应体，以确认收到 Webhook 事件。',
    'webhook.documentationLink': '查看此 Webhook 的文档',
    'webhook.modal.warning': '警告',
    'webhook.modal.confirmDelete': '确定要删除吗？',
    'webhook.channels.kiosk': '自助终端',
    'webhook.channels.web': 'CEL',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': '托盘扫描',
    'webhook.channels.vendingMachine': '自动售货机',
    'webhook.eventTypes.title': '事件类型',
    'webhook.eventTypes.subtitle': '可用事件类型：',
    'webhook.brand.title': 'Webhook 配置',
    'webhook.brand.firstpart.subtitle': '此 Webhook 的用途',
    'webhook.brand.firstpart.description':
        'Webhook 允许您在 Innovorder 系统中发生特定事件时实时接收通知。您可以配置 Webhook 以响应不同事件触发，例如客户数据更新、交易事件或订单通知。当事件发生时，Innovorder 将向您指定的端点发送 HTTP POST 请求并附带相关数据。',
    'webhook.brand.secondpart.subtitle': '如何配置 Webhook？',
    'webhook.brand.secondpart.description':
        '1. 提供您希望接收通知的 Webhook URL。\n2. 从可用选项中选择您要监控的事件类型。\n3. 选择需要触发该 Webhook 的渠道。\n4. 如端点有要求，可添加额外的 HTTP 头。\n5. Webhook 密钥将自动生成以确保安全。\n\n您的端点必须返回 HTTP 200 状态码以确认收到 Webhook 事件。',
    'webhook.system.badge': '系统',
    'webhook.system.readonly': '此 Webhook 由系统管理，无法修改。',
    'login.panelTitle': '欢迎使用您的后台管理系统',
    'login.login': '登录',
    'login.password': '密码',
    'login.ssoChecking': 'SSO 验证中…',
    'login.ssoEnabled': '该邮箱已启用 SSO。',
    'login.ssoLogin': '通过 SSO 登录',
    'login.ssoFailed': 'SSO 登录失败，请重试。',
    'login.ssoLoginRequired': '此账户需要通过 SSO 登录，正在跳转…',
    'login.noBrandsConfigured': '此用户未配置任何品牌。',
    'login.guestBrandLoginFailed': '登录失败，请重试。',
    'login.rememberMe': '记住我',
    'login.forgotPassword': '忘记密码？',
    'login.accountLocked': '账户暂时被锁定。请在 {minutes} 分钟后重试。',
    'login.captchaRequired': '需要安全验证。',
    'login.ipNotAllowed': '不允许从此 IP 地址登录。',
    'login.accountDisabled': '该账户因不活动已被停用。',
    'extendAccount.title': '账户延期',
    'extendAccount.loadingBody': '正在验证链接…',
    'extendAccount.successTitle': '账户已延期',
    'extendAccount.successBody': '您的账户已延期。您现在可以重新登录。',
    'extendAccount.invalidTitle': '链接无效',
    'extendAccount.invalidBody': '该延期链接无效或已过期。',
    'extendAccount.expiredHint': '如需恢复账户访问权限，请联系管理员。',
    'extendAccount.missingTokenBody': '链接不完整，请从您的邮箱重新打开链接。',
    'extendAccount.backToLogin': '返回登录',
    'forgotPassword.title': '忘记密码',
    'forgotPassword.subtitle': '请输入您的邮箱以接收重置链接。',
    'forgotPassword.submit': '发送链接',
    'forgotPassword.backToLogin': '返回登录',
    'forgotPassword.successTitle': '邮件已发送',
    'forgotPassword.successMessage': '如果该邮箱对应的账户存在，重置链接已发送。请检查您的收件箱。',
    'forgotPassword.recaptchaLoading': 'reCAPTCHA 加载中…',
    'forgotPassword.recaptchaFailed': 'reCAPTCHA 验证失败，请重试。',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA 不可用，请刷新页面后重试。',
    'forgotPassword.recaptchaNotConfigured': '配置缺失（REACT_APP_RECAPTCHA_SITE_KEY），请联系管理员。',
    'resetPassword.title': '设置新密码',
    'resetPassword.subtitle': '请为您的账户设置新密码。',
    'resetPassword.submit': '重置密码',
    'resetPassword.backToLogin': '返回登录',
    'resetPassword.successTitle': '密码已更新',
    'resetPassword.successMessage': '您的密码已成功更新，现在可以登录了。',
    'resetPassword.invalidLinkTitle': '链接无效',
    'resetPassword.invalidLink': '此重置链接无效或已过期，请从登录页面重新申请。',
    'resetPassword.passwordTooShort': '密码长度至少需要 {min} 个字符。',
    'resetPassword.passwordsMismatch': '两次输入的密码不一致。',
    'mfa.verify.title': '两步验证',
    'mfa.verify.subtitle': '请输入您的身份验证应用生成的 6 位验证码。',
    'mfa.verify.backupTitle': '备用验证码',
    'mfa.verify.backupSubtitle': '请输入您的一次性备用验证码。',
    'mfa.verify.submit': '验证',
    'mfa.verify.useBackupInstead': '改用备用验证码',
    'mfa.verify.useTotpInstead': '改用身份验证应用',
    'mfa.verify.useDifferentMethod': '使用其他方式',
    'mfa.verify.chooser.title': '选择验证方式',
    'mfa.verify.chooser.subtitle': '您希望使用哪种方式来验证身份？',
    'mfa.verify.chooser.webauthnHint': '使用您的安全密钥或生物识别。',
    'mfa.verify.chooser.totpHint': '输入您身份验证应用中的验证码。',
    'mfa.verify.failed': '验证码无效，请重试。',
    'mfa.verify.tokenExpired': 'MFA 会话已过期，请重新登录。',
    'mfa.verify.tabs.totp': '身份验证器应用',
    'mfa.verify.tabs.webauthn': '安全密钥 / 生物识别',
    'mfa.verify.webauthn.title': '使用安全密钥验证',
    'mfa.verify.webauthn.subtitle': '请轻触您的安全密钥，或使用 Touch ID 或其他平台身份验证器。',
    'mfa.verify.webauthn.authenticate': '验证',
    'mfa.verify.webauthn.failed': '验证失败，请尝试其他方式。',
    'mfa.verify.webauthn.noCredentials': '此账户尚未注册安全密钥。',
    'mfa.verify.webauthn.ceremonyFailed': '验证已取消或浏览器拒绝了请求，请重试。',
    'mfa.setup.title': '设置两步验证',
    'mfa.setup.subtitle':
        '请使用您的身份验证应用（Google Authenticator、1Password 等）扫描此二维码，然后输入生成的验证码。',
    'mfa.setup.loadingQr': '二维码加载中...',
    'mfa.setup.copySecret': '复制密钥',
    'mfa.setup.copied': '已复制！',
    'mfa.setup.confirm': '确认',
    'mfa.setup.invalidCode': '验证码无效，请检查应用的时间同步。',
    'mfa.setup.backupTitle': '保存您的备用验证码',
    'mfa.setup.backupSubtitle':
        '请将这些验证码保存在安全的地方。当您无法访问身份验证应用时，它们可用于登录。每个验证码只能使用一次。',
    'mfa.setup.backupAcknowledge': '我已保存验证码，继续',
    'mfa.setup.tabs.totp': '身份验证器应用',
    'mfa.setup.tabs.webauthn': '安全密钥 / 生物识别',
    'mfa.setup.webauthn.title': '注册安全密钥',
    'mfa.setup.webauthn.subtitle':
        '使用硬件密钥（YubiKey）、Touch ID、Windows Hello 或其他平台身份验证器。您可以为此设备命名，以便日后识别。',
    'mfa.setup.webauthn.deviceNamePlaceholder': "设备名称（例如：'我的电脑'）",
    'mfa.setup.webauthn.register': '注册',
    'mfa.setup.webauthn.ceremonyFailed': '注册被取消或浏览器拒绝了请求，请重试。',
    'mfa.setup.webauthn.finalizing': '正在完成安全密钥设置…',
    'activateAccount.title': '账户激活',
    'activateAccount.submit': '激活我的账户',
    'activateAccount.submitting': '激活中...',
    'activateAccount.loading': '令牌验证中...',
    'activateAccount.resend': '重新发送激活邮件',
    'activateAccount.resending': '发送中...',
    'activateAccount.renewSuccess': '新的激活邮件已发送，请检查您的收件箱。',
    'activateAccount.error.missingToken': '令牌缺失',
    'activateAccount.error.invalidToken': '令牌已过期',
    'activateAccount.error.password.minLength': '密码长度至少需要 {min} 个字符',
    'activateAccount.error.password.maxLength': '密码长度不能超过 {max} 个字符',
    'activateAccount.error.password.requireUppercase': '密码至少需要包含一个大写字母',
    'activateAccount.error.password.requireLowercase': '密码至少需要包含一个小写字母',
    'activateAccount.error.password.requireNumbers': '密码至少需要包含一个数字',
    'activateAccount.error.password.requireSpecialCharacters': '密码至少需要包含一个特殊字符',
    'activateAccount.password.placeholder': '密码',
    'activateAccount.confirmPassword.placeholder': '确认密码',
    'sidebar.overview': '概览',
    'sidebar.orders': '订单',
    'sidebar.customers': '顾客',
    'sidebar.brand': '品牌',
    'sidebar.brands': '品牌',
    'sidebar.restaurants': '餐厅',
    'sidebar.loyalty': '会员积分',
    'sidebar.coupons': '优惠码',
    'sidebar.paymentMeans': '支付方式',
    'sidebar.integrations': '集成',
    'sidebar.reports': '报表',
    'sidebar.reportsSales': '销售额',
    'sidebar.reportsEwallets': '徽章余额',
    'sidebar.monthly_sales_report': '月度销售报表',
    'sidebar.exports': '导出',
    'sidebar.exportsAccounting': '财务',
    'sidebar.exportsEwallets': '电子钱包',
    'sidebar.exportsSales': '财务汇总',
    'sidebar.salesSummary': '财务汇总',
    'sidebar.exportsPreInvoicing': '预开票',
    'sidebar.exportsBadge': '徽章流水',
    'sidebar.reportGenerationsHistory': '生成历史',
    'sidebar.help': '需要帮助？',
    'sidebar.languages': '语言',
    'sidebar.account': '我的账户',
    'sidebar.media': '媒体',
    'sidebar.marketplaces': '外卖平台',
    'sidebar.urssaf': 'URSSAF 最低限额',
    'sidebar.vatRatesMatrix': '税率参照表',
    'sidebar.autoBilling': '自动开票',
    'sidebar.logout': '退出登录',
    'sidebar.password': '我的密码',
    'sidebar.security': '安全',
    'security.title': '安全',
    'security.loading': '加载中…',
    'security.actions.remove': '删除',
    'security.actions.cancel': '取消',
    'security.totp.title': '身份验证器应用',
    'security.totp.subtitle': '由 Google Authenticator 或 1Password 等应用生成的一次性验证码。',
    'security.totp.label': '身份验证器应用',
    'security.totp.added': '添加于 {date}',
    'security.totp.empty': '尚未配置身份验证器应用。',
    'security.totp.add': '添加身份验证器应用',
    'security.totp.modalTitle': '设置身份验证器应用',
    'security.totp.confirmRemove': '确定要删除您的身份验证器应用吗？',
    'security.passkeys.title': '安全密钥和通行密钥',
    'security.passkeys.subtitle': '已为此账户注册的硬件密钥、Touch ID、Windows Hello 及其他身份验证器。',
    'security.passkeys.empty': '尚未注册任何安全密钥。',
    'security.passkeys.unnamedDevice': '未命名设备',
    'security.passkeys.lastUsed': '最后使用：{date}',
    'security.passkeys.added': '添加于 {date}',
    'security.passkeys.add': '添加安全密钥',
    'security.passkeys.confirmRemove': '确定要删除此密钥吗？删除后将无法再使用此设备登录。',
    'security.passkeys.ceremonyFailed': '注册已取消或浏览器拒绝了请求，请重试。',
    'security.passkeys.requestFailed': '出现错误，请重试。',
    'security.allowedIps.title': '允许的 IP 地址',
    'security.allowedIps.subtitle':
        '将您的登录限制为 IP 或 CIDR 范围列表。允许列表中的 IP 也会跳过 CAPTCHA 和锁定计数器。',
    'security.allowedIps.empty': '无限制。您可以从任何 IP 地址登录。',
    'security.allowedIps.add': '添加',
    'security.allowedIps.placeholder': '192.168.1.1 或 10.0.0.0/24',
    'security.allowedIps.invalid': 'IP 地址或 CIDR 范围无效。',
    'security.allowedIps.confirmRemoveTitle': '移除此 IP 地址？',
    'security.allowedIps.confirmRemove': '该地址将不再被允许登录您的账户。',
    'security.allowedIps.cancel': '取消',
    'security.allowedIps.warning': '警告：只要列表中至少包含一个条目，您将无法从其他 IP 登录。',
    'sidebar.billing': '我的账单中心',
    'sidebar.ioPay': '支付',
    'sidebar.news': '最新动态',
    'sidebar.analytics': '数据分析',
    'message.message': '消息',
    'name.name': '姓名',
    'name.firstName': '名',
    'name.lastName': '姓',
    'notFound.message': '抱歉，您访问的页面不存在。',
    'notFound.backToHome': '返回首页',
    'permissionDenied.title': '访问被拒绝',
    'permissionDenied.message': '很抱歉，您没有权限访问此页面。',
    'permissionDenied.backToHome': '返回首页',
    'errorPage.message': '很抱歉，我们遇到了技术问题，正在全力解决中！',
    'errorPage.support': '联系我们的支持团队',
    'file.noFile': '无文件',
    'file.cannotProcessJson': 'JSON 文件无法处理，请检查格式。',
    'file.fileNotAllowed': '不支持该文件类型。允许的扩展名：{allowedExtensionsString}',
    'file.fileTemplate': '文件模板',
    'file.metabaseLink': 'Metabase 链接',
    'fileInput.placeholder.title': '请插入您的文件！',
    'fileInput.placeholder.drop': '将文件拖放至此！',
    'fileInput.placeholder': '将一个或多个文件拖放到此窗口',
    'fileInput.browse': '从本地电脑导入',
    'imageInput.section.modal.title': '添加图片',
    'imageInput.section.modal.resize.label': '背景图片模式',
    'imageInput.section.modal.resize.details': '当上传的图片将用作自助终端或在线点餐的背景时，请使用此选项。',
    'imageInput.section.library.title': '从图库选择',
    'imageInput.section.upload.title': '从本地电脑上传',
    'languages.fr_FR': '法语',
    'languages.en_EN': '英语',
    'languages.it_IT': '意大利语',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': '西班牙语',
    'languages.zh-CN_ZH-CN': '中文（简体）',
    'languages.zh-TW_ZH-TW': '中文（繁体）',
    'languages.ar_AR': '阿拉伯语',
    'languages.de_DE': '德语',
    'button.add': '添加',
    'button.delete': '删除',
    'button.edit': '编辑',
    'button.configure': '配置',
    'button.cancel': '取消',
    'button.close': '关闭',
    'button.generate': '生成',
    'button.save': '保存',
    'button.import': '导入',
    'button.publish': '发布',
    'button.saveAndPublish': '保存并发布',
    'button.uploadFile': '上传文件',
    'button.previous': '上一步',
    'button.next': '下一步',
    'button.ok': '确定',
    'button.validate': '验证',
    'button.refresh': '刷新',
    'button.confirm': '确认',
    'button.yes': '是',
    'button.understand': '我已了解',
    'button.convertToCrossSell': '转换为附加销售',
    'button.convertToCustomization': '转换为个性化定制',
    'button.skipStep': '跳过此步骤',
    'button.block': '封禁',
    'button.unblock': '解封',
    'select.selectAll': '全选',
    'switch.activate': '启用',
    'form.preventLeave': '您有未保存的更改，确定要离开此页面吗？',
    'field.required': '此字段为必填项',
    'field.optional': '（可选）',
    'field.greaterThanZero': '此字段必须大于 0',
    'field.invalidEmail': '邮箱格式无效',
    'field.invalidURL': 'URL 格式无效',
    'field.atLeastOneEventType': '至少需要选择一种事件类型',
    'field.unmatchedPassword': '两次输入的密码必须一致',
    'field.invalidPassword': '密码至少需要 8 个字符',
    'field.invalidPhoneNumber': '手机号码无效',
    'field.duplicate_email': '该邮箱已存在',
    'field.duplicate_student_number': '该顾客编号已存在',
    'field.duplicate_badge_number': '该徽章编号已存在',
    'field.minTwo': '此字段至少需要 2 个字符',
    'field.ewallet_is_not_null_to_postpayment': '如需将顾客转换为后付款账户类型，其余额必须为 0€',
    'select.enabled': '已启用',
    'select.customised': '已自定义',
    'select.disabled': '已停用',
    'table.search': '搜索',
    'table.searchColumn': '搜索 {name}',
    'table.searchColumn.placeholder': '搜索值',
    'table.searchColumn.placeholder.from': '最小值',
    'table.searchColumn.placeholder.to': '最大值',
    'table.searchColumn.clearFilter': '清除筛选',
    'table.clearAllFilters': '清除所有筛选',
    'table.rowsPerPage': '每页行数',
    'table.firstPage': '首页',
    'table.lastPage': '末页',
    'table.noRowsAfterFilter': '没有与您的搜索匹配的结果',
    'table.noRowsAfterFilter.dateRangeHint': '是否尝试更改日期范围？',
    'table.noRowsAfterFilter.dateRangePresetHint': '过去 {days} 天内无结果。',
    'table.noRowsAfterFilter.dateRangeCustomHint': '所选时间段内无结果。',
    'table.noRowsAfterFilter.dateRangeAction': '请调整日期范围以显示订单。',
    'table.sort': '按 {name} 排序',
    'table.columnSelection.button': '列管理',
    'table.columnSelection.buttonFiltered': '列管理（{count}）',
    'table.columnSelection.header': '筛选列',
    'table.columnSelection.placeholder': '搜索列',
    'table.columnSelection.allEntries': '所有列',
    'table.selection.count': '已选择 {count} 行',
    'table.empty': '暂无数据',
    'pagination.previous': '上一页',
    'pagination.next': '下一页',
    'navigation.back': '返回',
    'navigation.next': '下一步',
    'navigation.disabled': '返回',
    'navigation.backToV1': '返回旧版本',
    'savingBar.changesDone': '{changesCount, plural, =0 {} one {# 项修改已完成} other {# 项修改已完成}}',
    'ticketLabel.name.mismatch.confirmation': '注意：产品名称已更改，但生产标签未同步更新。确认此更改吗？',
    'form.validation.integer': '此字段必须为整数',
    'form.validation.positive': '此字段必须为正数',
    'form.validation.positiveOrZero': '此字段必须为正数或零',
    'form.validation.length': '此字段必须包含 {length} 个字符',
    'form.validation.maxLength': '此字段超出允许的最大长度',
    'form.validation.email': '此字段必须为有效的邮箱地址',
    'form.validation.mustMatchValue': '此字段必须为 {value1} 或 {value2 }',
    'form.validation.siret.length': 'SIRET 号码必须为 14 位（不含空格）',
    'form.validation.siret.invalid': 'SIRET 号码无效',
    'integrations.section.title': '支付解决方案',
    'integrations.section.subtitle': '支付解决方案支持在线银行卡支付或门店 POS 机刷卡等功能。',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription': '将 Stripe 集成到您的网站，让顾客轻松连接账户，享受最佳的在线点餐体验。',
    'integrations.configured': '已配置',
    'integrations.notConfigured': '未配置',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        '所有 Webhook 集成均列于此处。点击"+"按钮可创建新的 Webhook，点击已有 Webhook 可进行编辑。状态指示器显示当前配置状态。',
    'pricingRule.emptyMessage': '此品牌暂无关联的定价方案。',
    'pricingRule.tableCard.title': '定价方案',
    'pricingRule.tableCard.subtitle': '定价方案是由一个或多个准入费、补贴及营业额外组件组合而成的集合。',
    'pricingRule.tableCard.description':
        '如果定价方案同时包含百分比补贴和固定金额补贴，请将需要优先从订单总金额中扣除的补贴放在首位。后续补贴将基于前序补贴扣除后的剩余金额计算。',
    'pricingRule.tableCard.action': '+ 创建新定价方案',
    'pricingRule.code': '编码',
    'pricingRule.applyScope': '策略',
    'pricingRule.strategy': '策略',
    'pricingRule.labelTicket': '票据标签',
    'pricingRule.grants_fees.amount': '金额',
    'pricingRule.grants_fees.dailyLimit': '每日上限',
    'pricingRule.grants': '补贴',
    'pricingRule.entranceFees': '准入费',
    'pricingRule.excludedTurnover': '营业额外',
    'pricingRule.associatedPricingRules': '关联定价方案',
    'pricingRule.action': '操作',
    'pricingRule.product': '餐食部分',
    'pricingRule.fee': '含准入权费用',
    'pricingRule.modal.warning': '警告',
    'pricingRule.modal.required': '「定价方案」字段为必填项',
    'pricingRule.modal.confirmDelete': '确定要删除吗？',
    'pricingRule.modal.delete.error.detail': '此定价方案已关联一个或多个顾客',
    'pricingRule.modal.unassociatedUser': '顾客将不再拥有定价方案',
    'pricingRule.modal.unassociatedUsers': '顾客将不再拥有定价方案',
    'pricingRule.form.title': '定价方案',
    'pricingRule.form.description': '通过分组现有补贴来配置定价方案。',
    'pricingRule.form.creation': '创建定价方案',
    'pricingRule.form.update': '修改定价方案',
    'pricingRule.form.pricingRuleCode': '定价方案编码',
    'pricingRule.form.applyScope': '策略',
    'pricingRule.form.authorizedChannels': '授权渠道',
    'pricingRule.form.isUrssafEnabled': '是否对此定价方案应用 URSSAF 最低限额？',
    'pricingRule.form.composition': '定义此定价方案的组成',
    'pricingRule.form.compositionDescription': '定价方案是由一个或多个准入费、补贴及营业额外组件组合而成的集合。',
    'pricingRule.emptyGrant': '此定价方案暂无关联补贴。',
    'pricingRule.emptyEntranceFee': '此定价方案暂无关联准入费。',
    'pricingRule.emptyTurnoverExcluded': '此定价方案暂无关联营业额外组件。',
    'pricingRule.emptyAssociatedPricingRule': '此定价方案暂无关联定价方案。',
    'pricingRule.noResult': '无结果',
    'pricingRule.addGrant': '添加补贴',
    'pricingRule.addEntranceFee': '添加准入费',
    'pricingRule.addComponentWithoutTurnover': '添加营业额外组件',
    'pricingRule.addAssociatedPricingRule': '添加关联定价方案',
    'pricingRule.search': '搜索定价方案',
    'pricingRule.channels.kiosk': '自助终端',
    'pricingRule.channels.pos': '收银台',
    'pricingRule.channels.web': '在线点餐',
    'pricingRule.channels.ewalletKiosk': '充值终端',
    'pricingRule.channels.vendingMachine': '自动售货机',
    'pricingRule.action.import': '导入',
    'pricingRule.action.export': '导出',
    'pricingRule.modal.import.title': '导入准入费、补贴及定价方案',
    'pricingRule.modal.import.firstPart': '下载 {fileTemplate} 到您的电脑',
    'pricingRule.modal.import.secondPart': '在模板文件中填写需要添加或修改的准入费、补贴及定价方案信息',
    'pricingRule.modal.import.thirdPart': '点击下方按钮导入您的新文件',
    'pricingRule.modal.import.warning': '准入费、补贴或定价方案的删除操作只能在 Innovorder 后台进行',
    'pricingRule.modal.import.secondWarning': '⚠️\n导入准入费或补贴将永久删除自定义值。\n（按餐厅或服务自定义的值）\n',
    'pricingRule.modal.import.report.title': '导入报告',
    'pricingRule.modal.import.report.result': '导入结果',
    'pricingRule.modal.import.report.success': '成功',
    'pricingRule.modal.import.report.error': '失败',
    'pricingRule.modal.import.report.warning': '警告',
    'pricingRule.modal.import.report.entranceFees': '准入费',
    'pricingRule.modal.import.report.grants': '补贴',
    'pricingRule.modal.import.report.pricingRules': '定价方案',
    'pricingRule.modal.import.report.successMessage': '• 创建：{created}\n • 修改：{updated}',
    'pricingRule.modal.import.report.errorMessage': '• 第 {line} 行 - {field}：{message}',
    'pricingRule.export.report.entranceFee.entranceFeeId': '准入费标识符',
    'pricingRule.export.report.entranceFee.code': '准入费编码',
    'pricingRule.export.report.entranceFee.labelTicket': '票据标签',
    'pricingRule.export.report.entranceFee.amount': '金额（欧元）',
    'pricingRule.export.report.entranceFee.dailyLimit': '每日上限',
    'pricingRule.export.report.entranceFee.strategy': '策略（1 = 始终 / 2 = 每日上限 + 关联产品）',
    'pricingRule.export.report.entranceFee.vat': '增值税',
    'pricingRule.export.report.entranceFee.type': '营业额（含/不含）',
    'pricingRule.export.report.entranceFee.type.admissionfee': '含',
    'pricingRule.export.report.entranceFee.type.royaltyfee': '不含',
    'pricingRule.export.report.entranceFee.active': '默认在所有餐厅启用（是/否）（仅适用于创建）',
    'pricingRule.export.report.grant.grantId': '补贴标识符',
    'pricingRule.export.report.grant.code': '补贴编码',
    'pricingRule.export.report.grant.labelTicket': '票据标签',
    'pricingRule.export.report.grant.threshold': '触发阈值（欧元，无则留空）',
    'pricingRule.export.report.grant.type': '金额类型（固定金额 / 百分比）',
    'pricingRule.export.report.grant.type.absolute': '固定金额',
    'pricingRule.export.report.grant.type.rate': '百分比',
    'pricingRule.export.report.grant.ceiling': '补贴上限（欧元，类型为百分比时必填）',
    'pricingRule.export.report.grant.amount': '金额（欧元）',
    'pricingRule.export.report.grant.dailyLimit': '每日上限',
    'pricingRule.export.report.grant.strategy': '策略（1 = 每日上限 + 金额 / 2 = 每日上限 + 金额 + 关联产品）',
    'pricingRule.export.report.grant.tag': '标签（无标签应用则留空）',
    'pricingRule.export.report.grant.active': '默认在所有餐厅启用（是/否）',
    'pricingRule.export.report.pricingRule.pricingRuleId': '定价方案标识符',
    'pricingRule.export.report.pricingRule.code': '定价方案编码',
    'pricingRule.export.report.pricingRule.canals': '渠道（收银台、充值终端、自动售货机、自助终端和/或在线点餐）',
    'pricingRule.export.report.pricingRule.isUrssafEnabled':
        '是否应用 URSSAF 最低限额（仅适用于购物车 API）？（是/否）',
    'pricingRule.export.report.pricingRule.entranceFees': '包含的准入费（填写编码，多项以逗号加空格分隔）',
    'pricingRule.export.report.pricingRule.grants': '包含的补贴（填写编码，多项以逗号加空格分隔）',
    'pricingRule.export.report.pricingRule.includeCA': '包含的营业额外',
    'pricingRule.export.report.pricingRule.applyScope': '策略（含准入权费用和/或餐食部分）',
    'pricingRule.export.report.pricingRule.applyScope.product': '餐食部分',
    'pricingRule.export.report.pricingRule.applyScope.fee': '含准入权费用',
    'entranceFee.create': '创建准入费',
    'entranceFee.title': '准入费',
    'entranceFee.description': '请为您所有门店填写准入费的名称、金额及规则。',
    'entranceFee.customUse': '准入费的特殊应用',
    'entranceFee.descCustomUse': '按餐厅启用及自定义准入费',
    'entranceFee.warningForm': '请在餐厅上启用准入费之前，确保所有字段均已填写完整。',
    'entranceFee.default': '默认',
    'entranceFee.code': '准入费编码',
    'entranceFee.codeAlreadyUsed': '准入费编码已被使用',
    'entranceFee.labelTicket': '票据标签',
    'entranceFee.amount': '金额',
    'entranceFee.vat': '增值税',
    'entranceFee.strategy': '策略',
    'entranceFee.dailyLimit': '每日上限',
    'entranceFee.type': '营业额',
    'entranceFee.select.always': '每日上限',
    'entranceFee.select.daily': '每日上限 + 关联产品',
    'entranceFee.select.salesExcluded': '不含',
    'entranceFee.select.salesIncluded': '含',
    'entranceFee.emptyMessage': '此品牌暂无关联的准入费。',
    'entranceFee.table.state': '启用状态',
    'entranceFee.table.services': '已启用服务',
    'entranceFee.table.state.enabled': '已启用',
    'entranceFee.table.state.customised': '已启用（含自定义值）',
    'entranceFee.table.state.disabled': '已停用',
    'entranceFee.tableCard.title': '准入费',
    'entranceFee.tableCard.subtitle': '创建并管理您餐厅使用的各种准入费',
    'entranceFee.tableCard.action': '+ 创建新准入费',
    'entranceFee.restaurants': '餐厅',
    'entranceFee.restaurant': '餐厅',
    'entranceFee.action': '操作',
    'entranceFee.modal.warning': '警告',
    'entranceFee.modal.confirmDelete': '确定要删除吗？',
    'entranceFee.search': '搜索准入费',
    'entranceFee.configuration.title': '准入费特殊应用 - {name}',
    'entranceFee.configuration.header.title': '管理此餐厅的服务',
    'entranceFee.configuration.search': '搜索服务',
    'entranceFee.configuration.table.activation': '启用',
    'entranceFee.configuration.table.name': '服务名称',
    'entranceFee.configuration.table.time': '时间段',
    'entranceFee.configuration.table.days': '周期',
    'entranceFee.configuration.table.amount': '金额',
    'entranceFee.configuration.table.vat': '增值税',
    'entranceFee.configuration.table.defaultShift': '默认服务',
    'entranceFee.warningShifts.title': '确认修改',
    'entranceFee.warningShifts.shift': '服务：{time} - 金额：{amount} - 差异：{variation}',
    'entranceFee.warningShifts.shift.amount': '\n准入费金额：{amount}',
    'entranceFee.warningShifts.confirm': '确定要继续吗？',
    'grant.create': '创建补贴',
    'grant.title': '补贴',
    'grant.description': '请为您所有门店填写补贴的金额及适用规则。',
    'grant.description.title1': '策略 1：每日上限 + 金额',
    'grant.customUse': '补贴的特殊应用',
    'grant.descCustomUse': '按餐厅启用及自定义补贴',
    'grant.warningLimit': '⚠️ 自定义每日上限不能高于默认设置的每日上限。',
    'grant.warningForm': '请在餐厅上启用补贴之前，确保所有字段均已填写完整。',
    'grant.desc1':
        '补贴适用于购物车中的所有产品，规则如下：\n        如设置了阈值，则仅对超出阈值的金额部分生效。\n        如设置了上限，则补贴金额不超过该上限。\n        如设置了标签，则仅对带有该标签的产品生效。\n        ',
    'grant.description.title2': '策略 2：每日上限 + 金额 + 关联产品',
    'grant.desc2':
        '补贴按照上述相同规则适用，此外：\n    如果补贴为百分比，则仅适用于标记为可补贴的产品。\n    如果补贴为固定金额，则仅在购物车中至少包含 1 件标记为可补贴的产品时才触发。',
    'grant.amount': '金额',
    'grant.default': '默认',
    'grant.code': '补贴编码',
    'grant.codeAlreadyUsed': '补贴编码已被使用',
    'grant.strategy': '策略',
    'grant.dailyLimit': '每日限额',
    'grant.type': '金额类型',
    'grant.tags': '仅适用于具有以下标签的产品：',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': '小票标签',
    'grant.select.rate': '百分比',
    'grant.select.absolute': '绝对值',
    'grant.select.minimum': '每日限额 + 金额',
    'grant.select.minimumAndProduct': '每日限额 + 最低金额 + 受影响产品',
    'grant.threshold': '触发阈值',
    'grant.ceiling': '补贴上限',
    'grant.restaurants': '餐厅',
    'grant.action': '操作',
    'grant.emptyMessage': '此品牌下暂无补贴。',
    'grant.tableCard.title': '补贴',
    'grant.tableCard.subtitle': '创建并管理餐厅中使用的各类补贴',
    'grant.tableCard.action': '+ 新增补贴',
    'grant.settings.button': '设置',
    'grant.settings.modal.title': '补贴设置',
    'grant.settings.modal.subtitle': '配置适用于您品牌补贴的规则。',
    'grant.settings.modal.toggle.label': '当应用补贴时，禁止使用餐券支付',
    'grant.settings.modal.toggle.description':
        '启用后，购物车中包含补贴的食客将无法在在线订单（CELV2）中使用餐券支付方式（Edenred、Paygreen）。',
    'grant.settings.modal.cancel': '取消',
    'grant.settings.modal.save': '保存',
    'grant.table.enabled': '启用',
    'grant.table.state': '启用状态',
    'grant.table.services': '已启用服务',
    'grant.table.state.enabled': '已启用',
    'grant.table.state.customised': '已启用（自定义值）',
    'grant.table.state.disabled': '已禁用',
    'grant.table.restaurant': '餐厅',
    'grant.table.threshold': '触发条件',
    'grant.table.ceiling': '上限',
    'grant.table.dailyLimit': '每日限额',
    'grant.table.strategy': '策略',
    'grant.table.action': '操作',
    'grant.modal.warning': '注意',
    'grant.modal.confirmDelete': '确定要删除吗？',
    'grant.search': '搜索补贴',
    'grant.configuration.title': '补贴专项配置 - {name}',
    'grant.configuration.header.title': '管理该餐厅的服务',
    'grant.configuration.search': '搜索服务',
    'grant.configuration.table.activation': '启用',
    'grant.configuration.table.name': '服务名称',
    'grant.configuration.table.time': '时间段',
    'grant.configuration.table.days': '日期范围',
    'grant.configuration.table.amount': '金额',
    'grant.configuration.table.threshold': '触发条件',
    'grant.configuration.table.ceiling': '上限',
    'grant.configuration.table.defaultShift': '默认班次',
    'grant.warningShifts.title': '确认修改',
    'grant.warningShifts.shift': '{time} - 金额：{amount} - 差额：{variation}',
    'grant.warningShifts.shift.amount': '\n补贴金额：{amount}',
    'grant.warningShifts.confirm': '确定要继续吗？',
    'group.tableCard.title': '分组',
    'group.tableCard.action': '+ 新建分组',
    'group.tableCard.subtitle': '按组定义就餐者的分组方式，并关联相应的定价规则。',
    'group.tableCard.subtitle2': '在此定义就餐者的各种组织方式。',
    'group.emptyMessage': '此品牌下暂无分组。',
    'group.name': '分组',
    'group.action': '操作',
    'group.pricingRules': '定价规则',
    'group.guestsCount': '就餐者人数',
    'group.guestsCountLabel': '就餐者',
    'group.modal.warning': '注意',
    'group.modal.confirmDelete': '确定要删除吗？',
    'group.modal.deleteError': '您无法删除该分组。',
    'group.modal.deleteErrorReason': '请先取消关联的就餐者，再完成删除操作。',
    'group.warning.group_name_already_exist.message': '该分组名称已存在。',
    'group.warning.group_name_already_exist.description': '请提供新的分组名称，或将所选定价规则关联到已有分组。',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        '您希望从当前分组解除关联的一个或多个定价规则已分配给现有就餐者。',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        '请先将相关定价规则从现有就餐者中解除关联，然后才能将其从该分组的可用定价规则列表中删除。',
    'group.modal.import.title': '导入分组、区域、子区域和定价规则',
    'group.modal.import.firstPart': '将 {fileTemplate} 下载到您的电脑',
    'group.modal.import.secondPart': '在模板文件中填写要添加或修改的分组、区域、子区域和定价规则信息',
    'group.modal.import.thirdPart': '点击下方按钮导入新文件',
    'group.modal.import.warning': '删除分组、区域、子区域和定价规则只能通过 Innovorder 后台操作',
    'group.modal.import.report.title': '导入报告',
    'group.export.group': '分组',
    'group.export.section': '区域',
    'group.export.subsection': '子区域',
    'group.export.pricingRule': '关联定价规则',
    'group.modal.conflict.error.message': '您无法修改该分组',
    'group.modal.conflict.error.description': '请先重新分配就餐者，再修改该分组',
    'group.modal.conflict.export.button': '导出就餐者',
    'group.modal.import.report.groups': '分组',
    'group.modal.import.report.sections': '区域',
    'group.modal.import.report.subsections': '子区域',
    'group.modal.import.report.successMessage': '• 创建：{created}\n • 修改：{updated}',
    'group.modal.import.report.errorMessage': '• 第 {line} 行 - 列 {field}：{message}',
    'group.delete.modal.conflict.error.message': '您无法删除该分组',
    'group.delete.modal.conflict.error.description': '请先重新分配就餐者，再删除该分组',
    'group.delete.modal.conflict.export.button': '导出就餐者',
    'groups.export.student.customerId': '客户ID',
    'groups.export.student.email': '邮箱',
    'groups.export.student.password': '密码',
    'groups.export.student.firstName': '名',
    'groups.export.student.lastName': '姓',
    'groups.export.student.phone': '电话',
    'groups.export.student.piCode': 'PIN码',
    'groups.export.student.badgeNumber': '徽章编号',
    'groups.export.student.studentNumber': '就餐者编号',
    'groups.export.student.group': '分组',
    'groups.export.student.section': '区域',
    'groups.export.student.subSection': '子区域',
    'groups.export.student.accountType': '账户类型',
    'groups.export.student.tariffCode': '价格代码',
    'groups.export.student.grantCode': '补贴代码',
    'groups.export.student.entranceFeeCode': '入场费代码',
    'groups.export.student.pricingRuleCode': '定价规则',
    'groups.export.student.ewalletOverdraftAmount': '自定义透支金额',
    'groups.export.student.exitDate': '归档日期',
    'groups.export.student.accessFrom': '到达日期',
    'groups.export.student.accessUntil': '离开日期',
    'groups.export.student.inactive': '停用',
    'groups.export.student.active': '启用',
    'groups.export.student.yes': '是',
    'groups.export.student.no': '否',
    'section.tableCard.title': '区域',
    'section.tableCard.subtitle': '按区域定义就餐者的分组方式，并关联相应的定价规则。',
    'section.tableCard.action': '+ 新建区域',
    'section.name': '区域',
    'group.warning.section_name_already_exist.message': '该区域名称已存在。',
    'group.warning.section_name_already_exist.description': '请提供新的区域名称，或将所选定价规则关联到已有区域。',
    'section.modal.conflict.error.message': '您无法修改该区域',
    'section.modal.conflict.error.description': '请先重新分配就餐者，再修改该区域',
    'section.delete.modal.conflict.error.message': '您无法删除该区域',
    'section.delete.modal.conflict.error.description': '请先重新分配就餐者，再删除该区域',
    'subsection.tableCard.title': '子区域',
    'subsection.tableCard.subtitle': '按子区域定义就餐者的分组方式，并关联相应的定价规则。',
    'subsection.tableCard.action': '+ 新建子区域',
    'subsection.name': '子区域',
    'group.warning.sub_section_name_already_exist.message': '该子区域名称已存在。',
    'group.warning.sub_section_name_already_exist.description':
        '请提供新的子区域名称，或将所选定价规则关联到已有子区域。',
    'subsection.modal.conflict.error.message': '您无法修改该子区域',
    'subsection.modal.conflict.error.description': '请先重新分配就餐者，再修改该子区域',
    'subsection.delete.modal.conflict.error.message': '您无法删除该子区域',
    'subsection.delete.modal.conflict.error.description': '请先重新分配就餐者，再删除该子区域',
    'options.main': '通用',
    'options.educationMode': '团餐',
    'options.birthdate': '生日',
    'options.tripAdvisorUsername': 'TripAdvisor 用户名',
    'options.advancedSecurityRules': '启用12位密码',
    'options.optIn': '营销许可',
    'options.productionDeclaration': '生产申报',
    'options.grantsAndEntranceFee': '补贴与入场费',
    'options.pinCodeDoubleAuth': '使用PIN码加强自助机登录安全性',
    'options.charlemagneExport': '导出Charlemagne数据',
    'options.handleBadgeForChar': '徽章搜索仅处理最后4个字符',
    'options.autoBilling': '启用「自动开票」模块',
    'options.linkProductImageBySku': '自动关联文件名包含产品SKU的图片（导入时）',
    'options.externalIdsMapping': '启用ID转换',
    'options.ewalletAutoReload': '启用 E-wallet 自动充值（通过 Stripe）',
    'options.foodCourt': 'CEL v2 - 美食广场',
    'options.foodCourtMode': '启用美食广场模式',
    'options.shuffleRestaurants': '随机显示餐厅顺序',
    'options.enableSodexoDictionary': '启用 Sodexo 词典',
    'options.enableOrderDetailV2': '启用订单详情 V2',
    'options.usePickupPoints': '启用取餐点',
    'options.linkProductSkuToExternalMapping': '自动将产品SKU关联到ID转换',
    'options.linkStudentNumberToExternalMapping': '自动将就餐者编号关联到ID转换',
    'options.multiRestaurant': '自助机 - 多餐厅',
    'options.multiRestaurantMode': '启用多餐厅模式',
    'options.multiRestaurantModeMainRestaurant': '主餐厅',
    'options.multiRestaurantModeMainUser': '自助机用户',
    'options.multiRestaurantModeAssignedRestaurants': '已分配餐厅',
    'options.enableLinkingMenuToPosAndWeb': '允许将菜单与POS及网络关联',
    'options.configureSodexoConsumerTransaction': '启用 Sodexo consumerTransactions Webhooks',
    'options.families': '分类',
    'options.families.empty': '暂无分类',
    'options.families.new': '新建分类',
    'options.families.namePlaceholder': '名称',
    'options.families.add': '添加',
    'options.families.delete': '删除',
    'options.families.deleteTitle': '确认删除分类 {name}',
    'options.families.deleteConfirmation': '确定要删除分类「{name}」吗？',
    'brandInfo.title': '信息',
    'brandInfo.ewalletOverdraft.title': 'E-wallet 透支',
    'brandInfo.ewalletOverdraft.description': '允许客户的电子钱包余额为负，最低至指定金额。',
    'brandInfo.ewalletOverdraft.enable': '启用电子钱包透支',
    'brandInfo.ewalletOverdraft.amount': '最大透支金额',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0.00',
    'brandInfo.ewalletOverdraft.cannotDisable': '无法禁用透支：{count} 位客户当前已启用后付款。',
    'restaurant.search': '搜索餐厅',
    'restaurant.name': '餐厅名称',
    'restaurant.options.main': '通用',
    'restaurant.options.includeDepositsInTurnover': '将押金计入营业额',
    'adminBanner.message': '您当前登录身份为',
    'adminBanner.backToAdmin': '切换回管理员',
    'auto.billing.buttons.referential': '参考资料',
    'auto.billing.buttons.billing': '开票申请',
    'auto.billing.request.card.title': '开票申请',
    'auto.billing.request.card.subtitle':
        '自动开票模块可汇总分配给第三方的所有就餐者消费，并根据配置规则计算每个第三方的营业额和实收金额。',
    'auto.billing.request.wizard.validate': '完成',
    'auto.billing.request.wizard.title': '提交开票申请',
    'auto.billing.request.card.action': '提交开票申请',
    'auto.billing.request.popup.confirm.title': '您即将发起自动开票请求',
    'auto.billing.request.popup.confirm.text': '请确认此操作。',
    'auto.billing.request.popup.success.title': '您的开票申请已通过',
    'auto.billing.request.popup.fail.title': '错误',
    'auto.billing.request.popup.pending.title': '处理中...',
    'auto.billing.request.popup.success.cancel': '关闭',
    'auto.billing.request.popup.success.text': '您的开票申请已成功提交',
    'auto.billing.request.popup.fail.text': '发生错误，请稍后重试',
    'auto.billing.request.preview.emptyMessage': '所选期间内无销售记录',
    'auto.billing.request.preview.errorUndefinedReferential': '该品牌未定义参考资料',
    'auto.billing.request.preview.error': '发生错误，请稍后重试',
    'auto.billing.request.preview.code': '代码',
    'auto.billing.request.preview.label': '名称',
    'auto.billing.request.preview.quantity': '数量',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': '不含税单价',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': '不含税金额',
    'auto.billing.request.preview.totalTax': '税额',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': '含税总额',
    'auto.billing.request.preview.cdpf': '发行方 CDPF',
    'auto.billing.request.preview.clientCode': '客户代码',
    'auto.billing.request.preview.clientLabel': '客户名称',
    'auto.billing.request.preview.billingPeriod': '开票周期',
    'auto.billing.request.preview.billingPeriod.from': '从',
    'auto.billing.request.preview.billingPeriod.to': '至',
    'auto.billing.request.preview.invoiceSelector.GROUP': '分组',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': '账户类型',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': '定价规则',
    'auto.billing.request.preview.total.amountWithTaxIncluded': '含税总计',
    'auto.billing.request.preview.total.amountWithTaxExcluded': '不含税总额',
    'auto.billing.request.preview.total.tax': '税额合计',
    'auto.billing.request.filter.title': '筛选',
    'auto.billing.request.filter.entities.title': '选择开票主体',
    'auto.billing.request.filter.entities.all': '所有主体',
    'auto.billing.request.filter.restaurants.title': '选择餐厅',
    'auto.billing.request.filter.dropDown.errorMessage': '至少选择一个选项',
    'auto.billing.request.filter.restaurants.all': '所有餐厅',
    'auto.billing.request.filter.pricingRules.title': '定价方案',
    'auto.billing.request.filter.pricingRules.all': '所有定价规则',
    'auto.billing.request.filter.pricingRules.noPricingRules': '无定价规则',
    'auto.billing.request.accountPaymentTypes.title': '管理模式',
    'auto.billing.request.filter.accountPaymentTypes.all': '所有管理模式',
    'auto.billing.request.accountPaymentTypes.CASH': '现付',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': '预付款',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': '后付款',
    'auto.billing.request.history.table.emptyMessage': '暂无开票申请记录',
    'auto.billing.request.history.table.date': '生成日期',
    'auto.billing.request.history.table.period': '周期',
    'auto.billing.request.history.table.user': '用户',
    'auto.billing.request.history.table.previewButton': '预览',
    'auto.billing.request.history.table.downloadButton': '下载',
    'auto.billing.referential.serviceCodes.card.title': '服务代码',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.card.title': '开票主体',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ 添加主体',
    'auto.billing.referential.billingEntities.form.create.title': '创建开票主体',
    'auto.billing.referential.billingEntities.form.create.subtitle': ' ',
    'auto.billing.referential.billingEntities.costCompute.title': '计算方式',
    'auto.billing.referential.billingEntities.costCompute.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': '名称',
    'auto.billing.referential.billingEntities.table.code': '代码',
    'auto.billing.referential.billingEntities.table.groups': '关联分组',
    'auto.billing.referential.billingEntities.table.groupingBy': '分类方式',
    'auto.billing.referential.billingEntities.table.emptyMessage': '该品牌暂未定义开票主体',
    'auto.billing.referential.billingEntities.form.label.title': '名称',
    'auto.billing.referential.billingEntities.form.code.title': '代码',
    'auto.billing.referential.billingEntities.form.code.text': '代码',
    'auto.billing.referential.billingEntities.form.groups.text': '目标',
    'auto.billing.referential.billingEntities.form.groupingBy.title': '分类类型',
    'auto.billing.referential.billingEntities.form.label.subtitle': '创建开票主体',
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': '定价规则',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': '不分类',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': '分组',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': '管理模式',
    'auto.billing.referential.billingEntities.errors.duplicate.code': '代码 {code} 已与开票主体 {entity} 关联',
    'auto.billing.referential.billingEntities.errors.duplicate.group': '开票主体 {entity} 已有以下分组：{groups}',
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': '代收款项',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': '按入场级别开票',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': '固定费用批量开票',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': '代收款项',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': '代码',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': '增值税',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ 添加代码',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': '暂未填写代码',
    'auto.billing.referential.accountingCostCompute.constantCost': '固定费用批量开票',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': '分段开票',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount': '按餐位开票',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': '固定费用批量',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount': '按餐位',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': '分段起始',
    'auto.billing.referential.accountingCostCompute.modal.to': '至',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': '固定费用批量',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount': '按餐位',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': '开票方式',
    'auto.billing.referential.accountingCostCompute.modal.title': '新增段位',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin': '最大段值必须大于最小段值',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection': '该段与 [{from} - {to}] 存在重叠',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': '值必须为正数',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ 添加段位',
    'auto.billing.referential.accountingCostCompute.amount': '含税金额',
    'auto.billing.filters.entity': '开票主体',
    'auto.billing.referential.accountingGroups.code.text': 'XXXX 分组代码',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': '餐位数量',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': '计算方式',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': '值',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage': '该开票方式暂无定义段位',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': '至',
    'route.brands': '品牌',
    'route.brandInfo': '信息',
    'route.brandInfoV2': '信息',
    'route.brandMedias': '媒体',
    'route.configIOPay': 'Adyen 配置',
    'route.configEdenred': 'Edenred 配置',
    'route.configPaygreen': 'Paygreen 配置',
    'route.integrations': '集成',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': '补贴与入场费',
    'route.options': '选项',
    'route.brandHistory': '历史记录',
    'route.groups': '层级结构',
    'route.brandChannels': '渠道',
    'route.brandMenus': '菜单',
    'route.brandMenu': '信息',
    'route.brandRestaurants': '餐厅',
    'route.brandUsers': '用户',
    'route.billing': '我的开票空间',
    'route.home': '首页',
    'route.pricingRule': '定价规则',
    'route.logout': '退出登录',
    'route.configUbereats': 'Uber Eats 集成',
    'route.configDeliveroo': 'Deliveroo 集成',
    'route.configDeliverect': 'Deliverect 集成',
    'route.configCrous': 'Crous 集成',
    'route.createGrant': '新建补贴',
    'route.grant': '补贴',
    'route.createEntranceFee': '新建入场费',
    'route.entranceFee': '入场费',
    'route.createPricingRule': '新建定价规则',
    'route.analytics': '总览',
    'route.restaurantIntegration': '集成',
    'route.autoBilling': '自动开票',
    'route.autoBilling.referential': '参考资料',
    'route.autoBilling.request': '开票申请',
    'route.autoBilling.referential.createEntity': '创建开票主体',
    'route.autoBilling.referential.editEntity': '编辑开票主体',
    'route.orders': '订单',
    'route.orderDetails': '订单详情',
    'route.restaurantInfo': '信息',
    'route.restaurantChannels': '渠道',
    'route.restaurantUsers': '用户',
    'route.restaurantMenus': '菜单',
    'route.restaurantMenu': '信息',
    'route.restaurantTickets': '小票',
    'route.restaurantMedias': '媒体',
    'route.restaurantIntegrations': '集成',
    'route.restaurantPayments': '支付方式',
    'route.restaurantOptions': '选项',
    'route.restaurantPricingRevaluation': '价格重估',
    'route.createGroup': '新建分组',
    'route.createSection': '新建区域',
    'route.createSubSection': '新建子区域',
    'route.editGroup': '编辑分组',
    'route.editSection': '编辑区域',
    'route.editSubSection': '编辑子区域',
    'route.adminTools': '管理工具',
    'route.menus': '菜单',
    'route.menuOperations': '菜单操作',
    'route.posLayout': 'POS 按键布局',
    'route.categories': '类别',
    'route.products': '产品',
    'route.steps': '步骤',
    'route.tags': '标签',
    'route.functions': '功能',
    'route.brandCustomer': '客户',
    'route.brandOrders': '订单',
    'route.crossSelling': '交叉销售',
    'route.tableLayout': '餐桌布局',
    'route.tableLayout.room': '包间',
    'route.salesSummary': '财务摘要',
    'route.tickets': '小票',
    'route.reportStatus': '报告状态',
    'route.pos': 'POS',
    'route.posConfiguration': '配置',
    'route.posDevices': '收银机',
    'route.posAccess': '角色与权限',
    'route.posAccess.users': '收银机用户',
    'route.posAccess.roles': '收银机角色',
    'route.posAccess.groups': '收银机分组',
    'route.accessFlags': '权限',
    'route.userRestaurants': '关联餐厅',
    'route.updateUserPassword': '修改密码',
    'route.userInfo': '信息',
    'route.badgeReader': '徽章读取器',
    'route.posDeviceInformation': '信息',
    'route.posDeviceConfiguration': '配置',
    'route.posDeviceAdditionalDevices': '外围设备',
    'route.posDeviceArchives': '财务归档',
    'route.posDeviceFeatures': '选项',
    'route.posDevicePreferences': '偏好设置',
    'route.posDeviceCatalogHistory': '目录历史',
    'route.listCustomers': '客户',
    'route.customerSettings': '设置',
    'route.customerPricingRules': '定价规则',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': '取餐点',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': '运营区域',
    'route.createBrandWebhook': '创建 Webhook',
    'route.editBrandWebhook': '编辑 Webhook',
    'operationZones.page.title': '运营区域',
    'operationZones.page.description': '定义您品牌的运营地域范围。必须为参考法律实体指定一个主要区域。',
    'operationZones.emptyState': '未选择区域',
    'operationZones.emptyState.description': '请从下方列表中选择一个或多个地域以定义运营区域。',
    'operationZones.availableTerritories': '可用地域',
    'operationZones.selectedCount': '已选 {count} 个',
    'operationZones.solution': '解决方案',
    'operationZones.warning.title': '配置不完整',
    'operationZones.warning.description':
        '{count, plural, one {{count} 个已选区域需要完成配置才能投入使用。} other {{count} 个已选区域需要完成配置才能投入使用。}}',
    'operationZones.warning.hint': '请通过「配置」按钮补充法律及技术信息。',
    'operationZones.immutabilityNotice':
        '餐厅创建后无法修改运营区域。如有需要，请<supportLink>联系客服</supportLink>。',
    'operationZones.primaryZone': '主要区域',
    'operationZones.setPrimary.disabled': '请先配置该区域，再将其设为主要区域',
    'operationZones.cannotRemoveLastZone': '餐厅至少需要一个运营区域',
    'operationZones.primaryBadge': '主要',
    'operationZones.secondaryZonesActive': '+ {count} 个{count, plural, one {活跃次要区域} other {活跃次要区域}}',
    'operationZones.configure': '配置',
    'operationZones.viewVatRates': '查看税率',
    'operationZones.toConfigure': '待配置',
    'operationZones.entity': '主体',
    'operationZones.vat': '增值税',
    'operationZones.posConfig': 'POS 配置',
    'operationZones.notFilled': '未填写',
    'operationZones.pending': '待处理',
    'operationZones.initialized': '已初始化',
    'operationZones.configured': '已配置',
    'operationZones.noPosDevice': '请先创建 POS 再配置该区域',
    'operationZones.configModal.title': '配置：{zoneName}',
    'operationZones.configModal.subtitle': '法律与税务参数（{code}）',
    'operationZones.configModal.entitySection': '主体信息',
    'operationZones.configModal.socialReason': '公司名称',
    'operationZones.configModal.address': '地址',
    'operationZones.configModal.postalCode': '邮政编码',
    'operationZones.configModal.city': '城市',
    'operationZones.configModal.vatNumber': '增值税号',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': '保存',
    'operationZones.configModal.socialReason.placeholder': '例：Restaurant SARL',
    'operationZones.configModal.address.placeholder': '123 Rue de la ...',
    'operationZones.configModal.postalCode.placeholder': '75000',
    'operationZones.configModal.city.placeholder': 'Paris',
    'operationZones.configModal.vatNumber.placeholder': '例：FR 12 345678901',
    'operationZones.configModal.siret.placeholder': '例：522 296...',
    'operationZones.multiProvider': '任选',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': '例：B12345678',
    'operationZones.configModal.fiscalRepresentative': '财税代表',
    'operationZones.configModal.fiscalRepresentative.placeholder': '财税代表姓名',
    'operationZones.configModal.fiscalIdCode': '税务识别码',
    'operationZones.configModal.fiscalIdCode.placeholder': '例：RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': '增值税号（BTW）',
    'operationZones.configModal.vatNumberBtw.placeholder': '例：BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': '企业编号',
    'operationZones.configModal.enterpriseNumber.placeholder': '例：0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': '例：12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': '例：001234567000045',
    'operationZones.configModal.selectProvider': '选择合规模式',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription': '收银机财税合规中间件',
    'operationZones.configModal.noIntegration': '无集成',
    'operationZones.configModal.noIntegrationDescription': '不配置任何税务中间件',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': '法国财税合规认证',
    'operationZones.configModal.boiteNoire': '黑盒',
    'operationZones.configModal.boiteNoireDescription': '比利时财税合规模块',
    'operationZones.configModal.middlewareSection': '中间件配置（Fiskaltrust）',
    'operationZones.configModal.cashboxId': '收银箱 ID',
    'operationZones.configModal.cashboxId.placeholder': '例：a1b2c3d4-...',
    'operationZones.configModal.accessToken': '访问令牌',
    'operationZones.configModal.accessToken.placeholder': '例：AZE123...',
    'operationZones.configModal.back': '返回',
    'operationZones.deactivate.title': '停用运营区域',
    'operationZones.deactivate.message': '确定要停用该运营区域吗？所有已配置信息（法律主体、税务、POS配置）将丢失。',
    'adminTools.confirmModal.description': '确定要触发此操作吗？',
    'brand.adminTools.editCustomerLoyalties.title': '为该品牌客户添加/扣除 IO 积分',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'name@domain.com 或 A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 相当于 4 欧元',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': '客户邮箱或会员卡号',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': '金额',
    'brand.adminTools.editCustomerLoyalties.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editCustomerLoyalties.form.success': '脚本已成功执行。',
    'brand.adminTools.unarchiveCustomer.title': '恢复归档就餐者',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': '要恢复的 CustomerId',
    'brand.adminTools.unarchiveCustomer.form.error': '脚本启动时发生错误。',
    'brand.adminTools.unarchiveCustomer.form.success': '脚本已成功执行。',
    'brand.adminTools.deleteTransaction.title': '删除交易',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': '要删除的交易',
    'brand.adminTools.deleteTransaction.form.error': '脚本启动时发生错误。',
    'brand.adminTools.deleteTransaction.form.success': '脚本已成功执行。',
    'brand.adminTools.addUserToRestaurant.title': '将餐厅账户分配到同一品牌的另一家餐厅',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'example@restaurant.com',
    'brand.adminTools.addUserToRestaurant.form.email': '账户邮箱',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': '要分配的餐厅 RestaurantId',
    'brand.adminTools.addUserToRestaurant.form.error': '脚本启动时发生错误。',
    'brand.adminTools.addUserToRestaurant.form.success': '脚本已成功执行。',
    'brand.adminTools.deleteUnassignedImages.title': '删除该品牌未使用的图片',
    'brand.adminTools.deleteUnassignedImages.description1':
        '此脚本用于清除所有未使用的图片（例如已删除的产品/菜单所关联的图片）',
    'brand.adminTools.deleteUnassignedImages.description2':
        '建议在执行此脚本前，先删除品牌及其餐厅的所有无用菜单，以确保清理效果。',
    'brand.adminTools.deleteUnassignedImages.form.error': '脚本启动时发生错误。',
    'brand.adminTools.deleteUnassignedImages.form.success': '脚本已成功执行。',
    'brand.adminTools.importGeojsonPolygon.title': '将 GeoJSON 导入为配送区域',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': '要创建的配送区域名称',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': '填写 GeoJSON 多边形坐标',
    'brand.adminTools.importGeojsonPolygon.form.error': '脚本启动时发生错误。',
    'brand.adminTools.importGeojsonPolygon.form.success': '脚本已成功执行。',
    'brand.adminTools.deleteCustomer.title': '删除客户/就餐者',
    'brand.adminTools.deleteCustomer.description1':
        '输入要删除的 customerId（可输入多个，以英文逗号分隔，不含空格，例如：1234567,1234568,1234569）',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': '要删除的 CustomerId',
    'brand.adminTools.deleteCustomer.form.error': '脚本启动时发生错误。',
    'brand.adminTools.deleteCustomer.form.success': '脚本已成功执行。',
    'brand.adminTools.razCustomer.title': '将客户/就餐者余额清零',
    'brand.adminTools.razCustomer.description1':
        '输入要清零 E-Wallet 余额的 customerId（可输入多个，以英文逗号分隔，不含空格，例如：1234567,1234568,1234569）',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': '要清零的 CustomerId（多个以逗号分隔）',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        '要清零的 BrandId（输入 brandId 后将清零该品牌所有后付款客户，CustomerId 字段将被忽略）',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date': '清零生效日期（时间为早上5点），如需立即执行请留空',
    'brand.adminTools.razCustomer.form.error': '脚本启动时发生错误。',
    'brand.adminTools.razCustomer.form.success': '脚本已成功执行。',
    'brand.adminTools.copySchedules.title': '将取餐或 CEL 时间表从一家餐厅复制到其他餐厅',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup 或 cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': '要复制的时间表类型（输入 pickup 或 cel）',
    'brand.adminTools.copySchedules.form.idSource': '来源 RestaurantId',
    'brand.adminTools.copySchedules.form.idsDestination':
        '目标 RestaurantId（可输入多个，以英文逗号分隔，不含空格，例如：901,902,903）',
    'brand.adminTools.copySchedules.form.error': '脚本启动时发生错误。',
    'brand.adminTools.copySchedules.form.success': '脚本已成功执行。',
    'brand.adminTools.changeOrderDateInReport.title': '编辑报表中的订单日期（同时更改交易日期）',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId': '订单编号（orderId），可用逗号分隔多个',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': '日',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': '例：14',
    'brand.adminTools.changeOrderDateInReport.form.month': '月',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': '例：7',
    'brand.adminTools.changeOrderDateInReport.form.year': '年',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': '例：2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': '时',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': '例：10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': '分',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': '例：35',
    'brand.adminTools.changeOrderDateInReport.form.error': '脚本启动时发生错误。',
    'brand.adminTools.changeOrderDateInReport.form.success': '脚本已成功执行。',
    'brand.adminTools.editPasswordExpiresAt.title': '强制品牌/就餐者修改密码',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force 或 cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': ' ',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        '强制修改密码（force）或取消修改密码要求（cancel）',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': '目标品牌',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        '目标就餐者（可输入多个 customerId，以英文逗号分隔，不含空格，例如：123456,234567,345678）。留空则针对整个品牌',
    'brand.adminTools.editPasswordExpiresAt.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editPasswordExpiresAt.form.success': '脚本已成功执行。',
    'brand.adminTools.editProductSkuFromProductId.title': '通过 Excel 文件批量编辑产品 SKU',
    'brand.adminTools.editProductSkuFromProductId.description': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.editProductSkuFromProductId.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editProductSkuFromProductId.form.success': '脚本已成功执行。',
    'brand.adminTools.importProductInMenu.title': '将产品导入到已有菜单',
    'brand.adminTools.importProductInMenu.description': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.importProductInMenu.form.error': '脚本启动时发生错误。',
    'brand.adminTools.importProductInMenu.form.success': '脚本已成功执行。',
    'brand.adminTools.importProductFromSku.title': '通过 SKU 编辑并导入产品',
    'brand.adminTools.importProductFromSku.description1':
        '使用此 {metabaseLink} 获取菜单产品列表，可编辑或新增产品（新产品 SKU 非必填）。',
    'brand.adminTools.importProductFromSku.description1bis':
        '请勿编辑现有产品的 SKU，这是产品的唯一标识符。不要更改列名。',
    'brand.adminTools.importProductFromSku.description2': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.importProductFromSku.form.error': '脚本启动时发生错误。',
    'brand.adminTools.importProductFromSku.form.success': '脚本已成功执行。',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': '来源菜单的 menuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': '来源菜单的 MenuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination': '目标菜单的 menuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': '目标菜单的 MenuId',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '（可选）',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': '类别筛选',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '（可选）',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': '标签筛选',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': '将产品从一个菜单复制到另一个菜单',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        '输入来源菜单和目标菜单的 menuId。还可按类别和/或标签筛选，仅复制特定产品。',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2': '注意：外部引用和步骤不会被复制',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        '仅当目标菜单与来源菜单在同一餐厅，或来源菜单在品牌级别而目标菜单在同一品牌的餐厅级别时，图片才会被复制',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error': '脚本启动时发生错误。',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': '脚本已成功执行。',
    'brand.adminTools.importBackofficeUsers.title': '导入后台用户',
    'brand.adminTools.importBackofficeUsers.description': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.importBackofficeUsers.form.error': '脚本启动时发生错误。',
    'brand.adminTools.importBackofficeUsers.form.success': '脚本已成功执行。',
    'brand.adminTools.editProductInfoFromProductId.title': '通过 Excel 文件编辑产品信息',
    'brand.adminTools.editProductInfoFromProductId.description1':
        '使用此 {metabaseLink} 获取菜单产品列表，填写编辑列并上传文件（不要更改列名）。',
    'brand.adminTools.editProductInfoFromProductId.description2': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.editProductInfoFromProductId.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editProductInfoFromProductId.form.success': '脚本已成功执行。',
    'brand.adminTools.editStepInfoFromStepId.title': '通过 Excel 文件编辑步骤信息',
    'brand.adminTools.editStepInfoFromStepId.description0':
        '此脚本用于批量修改步骤的名称、引用和标签，不包括产品列表。',
    'brand.adminTools.editStepInfoFromStepId.description1':
        '使用此 {metabaseLink} 获取菜单步骤列表，填写编辑列并上传文件（不要更改列名）。',
    'brand.adminTools.editStepInfoFromStepId.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editStepInfoFromStepId.form.success': '脚本已成功执行。',
    'brand.adminTools.editProductPriceInAdminTools.title': '通过 Excel 文件编辑产品价格（含步骤内外）',
    'brand.adminTools.editProductPriceInAdminTools.description1':
        '使用此 {metabaseLink} 获取菜单产品列表，填写「新价格」列并上传文件（不要更改列名）。',
    'brand.adminTools.editProductPriceInAdminTools.description2': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.editProductPriceInAdminTools.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editProductPriceInAdminTools.form.success': '脚本已成功执行。',
    'brand.adminTools.editProductTagFromProductId.title': '通过 Excel 文件为多个产品批量添加标签',
    'brand.adminTools.editProductTagFromProductId.description': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.editProductTagFromProductId.form.error': '脚本启动时发生错误。',
    'brand.adminTools.editProductTagFromProductId.form.success': '脚本已成功执行。',
    'brand.adminTools.makeEwalletTransaction.title': '通过 Excel 文件批量进行 E-Wallet 交易',
    'brand.adminTools.makeEwalletTransaction.description': '将 {fileTemplate} 下载到您的电脑',
    'brand.adminTools.makeEwalletTransaction.form.error': '脚本启动时发生错误。',
    'brand.adminTools.makeEwalletTransaction.form.success': '脚本已成功执行。',
    'brand.adminTools.bulkUploadDualScreenImage.title': '批量上传品牌所有收银机的双屏图片',
    'brand.adminTools.bulkUploadDualScreenImage.description':
        '上传一张图片（PNG 或 JPG）并输入 brandId，图片将应用于该品牌的所有收银机。',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': '请输入 Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': '图片已上传至所有收银机。',
    'brand.adminTools.transformGuestFile.title': '将从新网站获取的就餐者文件转换为 Innovorder 格式',
    'brand.adminTools.transformGuestFile.fileFormat': '原始文件格式',
    'brand.adminTools.transformGuestFile.form.success': '文件已成功转换',
    'brand.adminTools.transformGuestFile.form.url': '点击此处下载文件',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': '将 IO 销售数据同步至 Sodexo SI',
    'brand.adminTools.generateSalesReport.description':
        '将指定餐厅的 IO 销售数据同步至 Sodexo SI（若使用时间段，则同步所选时间段内的销售数据）',
    'brand.adminTools.generateSalesReport.form.checkbox': '使用时间段',
    'brand.adminTools.generateSalesReport.form.restaurant': '选择餐厅',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title': '将产品 SKU 关联到外部 ID 映射',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        '为指定菜单的内部 productId 与产品 SKU 创建映射关系',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': '餐厅',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': '菜单',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': '脚本已成功执行。',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error': '脚本启动时发生错误。',
    'spotlight.search.placeholder': '您想做什么？',
    'spotlight.section.suggestion': '建议',
    'spotlight.section.history': '历史记录',
    'spotlight.context.brand': '品牌',
    'spotlight.context.restaurant': '餐厅',
    'spotlight.error.noHistory': '您尚无符合条件的历史记录 URL',
    'orderList.title': '订单',
    'orderList.subtitle': '查找您的客户及好友的订单',
    'orderList.filters.allRestaurants': '所有餐厅',
    'orderList.filters.restaurantHeader': '我的餐厅',
    'orderList.filters.restaurantPlaceholder': '搜索餐厅',
    'orderList.filters.dateRange.lastXdays': '最近 {days} 天',
    'orderList.filters.dateRange.custom': '自定义',
    'orderList.generation_history': '生成历史',
    'orderList.export': '导出',
    'orderList.generate': '生成',
    'orderList.export.title': '导出',
    'orderList.export.selectOneDay': '选择某一天',
    'orderList.export.selectPeriod': '选择时间段',
    'orderList.export.format': '选择导出格式',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': '最多只能选择 31 天',
    'orderList.export.presetDate.currentWeek': '本周',
    'orderList.export.presetDate.currentMonth': '本月',
    'orderList.export.presetDate.lastMonth': '上个月',
    'orderList.export.presetDate.chooseDate': '请选择时间段',
    'orderList.export.includeOrderStates': '包含订单的各种状态',
    'order.field.ticketNumber': '票据编号',
    'order.field.status': '状态',
    'order.field.restaurant': '餐厅',
    'order.field.channel': '渠道',
    'order.field.customerName': '姓名',
    'order.field.customerNameMassCatering': '用餐者姓名',
    'order.field.badgeNumber': '徽章编号',
    'order.field.phone': '电话号码',
    'order.field.pricingRule': '定价方案',
    'order.field.pricingRuleInOrder': '已应用的定价方案',
    'order.field.company': '公司',
    'order.field.orderId': '订单编号',
    'order.field.consumptionMode': '消费模式',
    'order.field.orderDate': '订单日期',
    'order.field.expectedDate': '预计配送日期',
    'order.field.ticketDate': '票据日期',
    'order.field.totalWithVat': '含税总计',
    'order.field.turnoverWithVat': '含税营业额',
    'order.field.paymentMethod': '支付方式',
    'order.field.paymentStatus': '支付状态',
    'order.field.paymentAmount': '支付金额',
    'order.status.PAID': '已付款',
    'order.status.CANCELLED': '已取消',
    'order.status.VALIDATED': '已确认',
    'order.status.PAID_CANCELLED': '已付款（已取消）',
    'order.status.CONTRA_ENTRY': '对冲分录',
    'order.status.INCOHERENT': '订单异常',
    'order.channel.': '未知',
    'order.channel.1': '自助终端',
    'order.channel.2': 'CEL',
    'order.channel.5': '收银台',
    'order.channel.8': 'DA',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': '配送',
    'order.consumptionMode.2': '外带',
    'order.consumptionMode.3': '堂食',
    'order.consumptionMode.4': '得来速',
    'order.webPaymentStatus.PAYMENT_OK': '已付款',
    'order.webPaymentStatus.PAYMENT_PENDING': '未付款',
    'order.webPaymentStatus.PAYMENT_REFUSED': '支付被拒',
    'order.webPaymentStatus.PAYMENT_REFUNDED': '已退款',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': '现金',
    'order.paymentMethod.Change': '找零',
    'order.paymentMethod.Check': '支票',
    'order.paymentMethod.CreditCard': '银行卡',
    'order.paymentMethod.CreditNote': '贷记凭证',
    'order.paymentMethod.CreditNoteIssued': '已开贷记凭证',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': '电子餐券',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': '外部支付',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': '餐饮券',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': '在线银行卡',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': '转账',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': '其他',
    'order.paymentMethod.Unknown2': '其他 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': '请联系支持人员以处理该订单',
    'orderDetail.title.1': '自助终端',
    'orderDetail.title.2': '在线订单',
    'orderDetail.title.5': '收银台',
    'orderDetail.title.8': '自动售货',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': '对冲分录订单',
    'orderDetail.status.PAID': '收款',
    'orderDetail.status.VALIDATED': '账单',
    'orderDetail.status.CANCELLED': '已取消',
    'orderDetail.tabStatus.PAID': '已付款销售',
    'orderDetail.tabStatus.VALIDATED': '已确认购物车',
    'orderDetail.tabStatus.CANCELLED': '取消',
    'orderDetail.paymentStatus.PAID': '已付款',
    'orderDetail.paymentStatus.CANCELLED': '已取消',
    'orderDetail.paymentStatus.REFUNDED': '已退款',
    'orderDetail.shift.default': '默认班次',
    'orderDetail.header.guestNumber': '用餐人数：',
    'orderDetail.header.currency': '货币：',
    'orderDetail.header.orderedAt': '下单时间',
    'orderDetail.header.deliverAt': '预计配送时间',
    'orderDetail.header.deliverAtRange': '预约时段：',
    'orderDetail.header.status': '状态',
    'orderDetail.header.payment': '支付',
    'orderDetail.header.table': '桌号',
    'orderDetail.kpi.date': '{date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': '{start, date, ::HHmm} 至 {end, date, ::HHmm}',
    'orderDetail.ticketInfo': '订单详情',
    'orderDetail.comment': '备注',
    'orderDetail.userName': '客户姓名',
    'orderDetail.taxInfo': '增值税详情',
    'orderDetail.paymentInfo': '支付方式',
    'orderDetail.customerInfo': '客户信息',
    'orderDetail.deliveryInfo': '配送',
    'orderDetail.loyaltyInfo': '积分',
    'orderDetail.posInfo': '收银台信息',
    'orderDetail.transactionInfo': '交易详情',
    'orderDetail.orderPhotos': '订单相关照片',
    'orderDetail.customer.name': '名字和姓氏',
    'orderDetail.customer.email': '电子邮件',
    'orderDetail.customer.phone': '电话号码',
    'orderDetail.customer.badgeNumber': '徽章编号',
    'orderDetail.customer.pricingRule': '定价方案',
    'orderDetail.customer.pricingRuleAssigned': '已分配定价方案',
    'orderDetail.customer.group': '分组',
    'orderDetail.customer.section': '部门',
    'orderDetail.customer.subSection': '子部门',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': '订单前 E-Wallet 余额',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': '订单后 E-Wallet 余额',
    'orderDetail.Pos.restaurant': '餐厅',
    'orderDetail.Pos.seller': '操作员',
    'orderDetail.Pos.deviceName': '收银台名称',
    'orderDetail.Pos.deviceId': 'POS ID',
    'orderDetail.action.text': '订单操作',
    'orderDetail.action.cancel': '取消',
    'orderDetail.action.refund': '退款',
    'orderDetail.action.cancelWithContraEntry': '取消订单（对冲分录）',
    'orderDetail.cancel.title.reason': '取消订单',
    'orderDetail.cancel.title.manualPaymentMethod': '退款支付方式',
    'orderDetail.cancel.text1': '如有需要，您可以取消客户的订单。',
    'orderDetail.cancel.text2': '您必须在下方选择取消原因。',
    'orderDetail.cancel.text3': '如果原因不在列表中，请点击「其他」。',
    'orderDetail.cancel.text4': '您选择的原因将通过邮件发送给客户。',
    'orderDetail.cancel.text5': '扣减的产品数量将恢复至库存。',
    'orderDetail.cancel.text6': '您可以选择与退款关联的支付方式。',
    'orderDetail.cancel.text7': '⚠️ 必须向客户进行实体退款，以避免账目差异。',
    'orderDetail.cancel.reason.description.label': '自由文本（可选）',
    'orderDetail.cancel.reason.placeholder': '选择取消原因',
    'orderDetail.cancel.reason.description.placeholder': '最多 250 个字符',
    'orderDetail.cancel.manualPaymentMethod.placeholder': '选择支付方式',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': '无法完成订单',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': '下单错误',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER': '客户不满意（数量不恢复库存）',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': '客户未到场',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': '客户已离开',
    'orderDetail.cancel.reason.LEARNING_MODE': '培训',
    'orderDetail.cancel.reason.TECHNICAL': '技术错误',
    'orderDetail.cancel.reason.OTHER': '其他...',
    'orderDetail.cancel.manualPaymentMethod.Cash': '现金',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': '银行卡',
    'orderDetail.cancel.confirm': '取消订单',
    'orderDetail.cancel.validate': '确认取消',
    'orderDetail.ticket.itemSum': '商品合计',
    'orderDetail.ticket.grantSum': '补贴合计',
    'orderDetail.ticket.entranceFeeSum': '入场费合计',
    'orderDetail.ticket.pricingRule': '定价方案：',
    'orderDetail.ticket.discountSum': '折扣合计',
    'orderDetail.ticket.tvaSum': '增值税合计',
    'orderDetail.ticket.finalPrice': '总计',
    'orderDetail.ticket.discount': '优惠码：',
    'orderDetail.tax.taxrate': '增值税率',
    'orderDetail.tax.totalExclTax': '不含税',
    'orderDetail.tax.totalTax': '增值税',
    'orderDetail.tax.totalInclTax': '含税',
    'orderDetail.transaction.transactionIds': '交易标识符',
    'orderDetail.payment.quantity': '数量',
    'orderDetail.payment.price': '价格',
    'orderDetail.delivery.address': '地址',
    'orderDetail.delivery.apartmentNumber': '公寓号',
    'orderDetail.delivery.digicode': '门禁密码',
    'orderDetail.delivery.phoneNumber': '电话号码',
    'orderDetail.delivery.additionalInfo': '补充信息',
    'orderDetail.linkedOrder.title.origin': '与对冲分录订单的关联',
    'orderDetail.linkedOrder.title.contra_entry': '与已取消订单的关联',
    'orderDetail.linkedOrder.date.origin': '对冲分录订单日期',
    'orderDetail.linkedOrder.date.contra_entry': '已取消订单日期',
    'orderDetail.contraEntryInfo.title': '对冲分录信息',
    'orderDetail.contraEntryInfo.validator': '审核人',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': '自由文本',
    'route.ioPayTransactions': '交易',
    'route.ioPayReports': '报告',
    'route.ioPayTransfers': '转账',
    'route.ioPayConfiguration': '配置',
    'route.ioPayTransferDetail': '转账详情',
    'route.ioPayTransactionDetail': '交易详情',
    'ioPay.title': 'Adyen',
    'transactions.title': '交易',
    'transactions.detail.title': '交易详情',
    'transactions.subtitle': '查看您的客户交易记录',
    'transaction.field.id': 'Id',
    'transaction.field.type': '类型',
    'transaction.field.brand': '品牌',
    'transaction.field.customerEmail': '电子邮件',
    'transaction.field.date': '日期',
    'transaction.field.paymentMethod': '支付方式',
    'transaction.field.paymentStatus': '支付模式',
    'transaction.field.paymentAmount': '支付金额',
    'transaction.field.paymentAmount.tooltip': '客户支付金额',
    'transaction.field.reversalAmount': 'Innovorder 返还金额',
    'transaction.field.reversalAmount.tooltip':
        '仅扣除支付手续费后返还的金额（如果资金不经过 Innovorder 而直接转入您的银行账户，金额可能为负数）',
    'transaction.field.amount': '交易金额',
    'transaction.field.amount.tooltip': 'Innovorder 返还金额总和减去退款',
    'transaction.field.fee': '手续费',
    'transaction.field.channel': '渠道',
    'transaction.field.transfer': '转账',
    'transaction.field.currency': '货币',
    'transaction.field.status': '状态',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': '姓名',
    'transaction.field.email': '电子邮件',
    'transaction.field.customerId': '客户 ID',
    'transaction.field.badgeNumber': '徽章编号',
    'transaction.field.lastUpdate': '更新日期',
    'transaction.field.source': '来源',
    'transaction.field.orderId': '订单编号',
    'transaction.field.error': '错误',
    'transaction.field.restaurant': '餐厅',
    'transaction.field.paymentMethodType.WEB': '在线银行卡',
    'transaction.field.paymentMethodType.PROXIMITY': '银行卡',
    'transaction.field.paymentMethod.MEAL_VOUCHER': '餐券',
    'transaction.field.paymentMethod.BANK_CARD': '银行卡',
    'transaction.status.PENDING': '处理中',
    'transaction.status.PENDING_3DS': '3DS 处理中',
    'transaction.status.DONE': '成功',
    'transaction.status.FAILED': '拒绝',
    'transaction.status.ERROR': '错误',
    'transaction.type.CAPTURE': '支付',
    'transaction.type.REFUND': '退款',
    'transaction.channel.WEB': '网络',
    'transaction.channel.PROXIMITY': '近场',
    'transaction.source.WEBORDERING': '在线订单',
    'transaction.source.EWALLET': 'E-Wallet 充值',
    'transaction.source.KIOSK': '自助终端',
    'transaction.source.NOTIFICATION': '通知',
    'transaction.detail.card.main': '交易详情',
    'transaction.detail.card.finance': '财务数据',
    'transaction.detail.card.web': '网络数据信息',
    'transaction.detail.card.customer': '客户信息',
    'transaction.detail.card.order': '关联订单',
    'transaction.detail.card.paymentMethod': '支付方式',
    'transfers.title': '转账',
    'transfers.subtitle': '账户转账',
    'configuration.iopay.title': 'Adyen 配置',
    'configuration.iopay.subtitle':
        '在此您可以查看为您的企业创建的所有法律实体。我们为您汇总了餐厅和 E-Wallet 的清晰概览，以便于配置管理。',
    'configuration.error.unaccessible': '未找到或权限不足',
    'transfer.field.id': 'Id',
    'transfer.field.ref': '参考编号',
    'transfer.field.configurationName': '商户',
    'transfer.field.amount': '转账金额',
    'transfer.field.transactionCount': '交易笔数',
    'transfer.field.status': '状态',
    'transfer.field.executedAt': '执行日期',
    'transfer.status.PENDING': '处理中',
    'transfer.status.SUCCESS': '已确认',
    'transfer.status.SENT_OUT': '已发送',
    'transfer.status.FAILED': '失败',
    'transfer.kpi.date': '{date, date} {date, time, ::HHmm}',
    'transfer.detail.title': '转账详情',
    'transfer.transactions.title': '转账交易',
    'legalEntity.field.entity': '法律实体',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': '城市',
    'legalEntity.field.status': '状态',
    'legalEntity.field.associatedRestaurants': '关联餐厅',
    'legalEntity.field.actions': '操作',
    'legalEntity.create.title': '创建法律实体',
    'legalEntity.status.1': 'KYC 错误',
    'legalEntity.status.2': '待完善',
    'legalEntity.status.3': '处理中',
    'legalEntity.status.4': '正常',
    'legalEntity.action.addRestaurant': '添加餐厅',
    'legalEntity.action.addEwallet': '添加 E-Wallet',
    'legalEntity.action.completeKyc': '完成 KYC',
    'legalEntity.action.updateKyc': '更新 KYC',
    'legalEntity.wizard.step1.title': '创建新法律实体',
    'legalEntity.wizard.step1.legalName': '公司法定名称',
    'legalEntity.wizard.step1.legalName.placeholder': '请输入与 SIRET 上完全一致的公司法定名称',
    'legalEntity.wizard.step1.legalName.tooltip': '与 SIRET 上完全一致的公司法定名称',
    'legalEntity.wizard.step1.organizationType': '组织类型',
    'legalEntity.wizard.step1.organizationType.placeholder': '请选择您的组织类型',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': '请输入您的 SIRET',
    'legalEntity.wizard.step1.siret.tooltip': '公司 SIRET',
    'legalEntity.wizard.step1.addressStreet': '法律实体地址',
    'legalEntity.wizard.step1.addressStreet.placeholder': '请输入法律实体地址',
    'legalEntity.wizard.step1.addressStreet2': '补充地址（可选）',
    'legalEntity.wizard.step1.addressStreet2.placeholder': '如有需要请输入补充地址',
    'legalEntity.wizard.step1.addressZipcode': '邮政编码',
    'legalEntity.wizard.step1.addressZipcode.placeholder': '请输入您的邮政编码',
    'legalEntity.wizard.step1.addressCity': '城市',
    'legalEntity.wizard.step1.addressCity.placeholder': '请输入您的城市',
    'legalEntity.wizard.step1.industryCode': '行业代码',
    'legalEntity.wizard.step1.contactEmail': '联系邮箱',
    'legalEntity.wizard.step1.contactEmail.placeholder': '请输入与此法律实体关联的电子邮件地址',
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': '请输入法律实体的 IBAN',
    'legalEntity.wizard.step1.iban.tooltip': '法律实体的 IBAN',
    'legalEntity.wizard.step2.title': '添加新餐厅',
    'legalEntity.wizard.step2.titleMassCatering': '添加新餐厅或 E-Wallet',
    'legalEntity.wizard.step2.chooseRestaurant': '选择餐厅',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': '选择餐厅或 E-Wallet',
    'legalEntity.wizard.step2.completeFieldsTitle': '需填写的字段',
    'legalEntity.wizard.step2.conecsTitle': 'CONECS 标识符',
    'legalEntity.wizard.step2.conecsTitleOptional': '（可选）',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        '填写 CONECS 标识符（ID）以便在此餐厅启用 CONECS 近场支付方式',
    'legalEntity.wizard.step2.ewallet': 'E-Wallet',
    'legalEntity.wizard.step2.selectRestaurant': '餐厅',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': '餐厅或 E-Wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': '请选择餐厅',
    'legalEntity.wizard.step2.phoneNumber': '电话号码',
    'legalEntity.wizard.step2.phoneNumber.placeholder': '请输入与此餐厅关联的电话号码',
    'legalEntity.wizard.step2.shopperStatement': '银行账单标题',
    'legalEntity.wizard.step2.shopperStatement.placeholder': '请输入将显示在银行账单上的标题',
    'legalEntity.wizard.step2.shopperStatement.tooltip': '最终客户银行账单上显示的标注',
    'legalEntity.wizard.step2.restaurantAddressStreet': '餐厅地址',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': '请输入餐厅地址',
    'legalEntity.wizard.step2.restaurantAddressStreet2': '补充地址（可选）',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder': '如有需要请输入补充地址',
    'legalEntity.wizard.step2.restaurantAddressZipcode': '餐厅邮政编码',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': '请输入餐厅邮政编码',
    'legalEntity.wizard.step2.restaurantAddressCity': '城市',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': '请输入餐厅所在城市',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': '请输入用于资金转账的 IBAN',
    'legalEntity.wizard.step2.restaurantIban.tooltip': '填写 CONECS 标识符（ID）以便在此餐厅启用 CONECS 近场支付方式',
    'legalEntity.wizard.step2.conecsId': 'CONECS MID',
    'legalEntity.wizard.step2.conecsId.placeholder': '请输入授权卡上的 CONECS MID',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'CONECS 合同关联 SIRET',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder': '请输入与 CONECS 合同关联的 SIRET',
    'legalEntity.organizationType.1': '私人公司',
    'legalEntity.organizationType.2': '上市公司',
    'legalEntity.organizationType.3': '合伙企业',
    'legalEntity.organizationType.4': '非营利组织或慈善机构',
    'legalEntity.organizationType.5': '政府机构',
    'legalEntity.organizationType.6': '法人组织',
    'legalEntity.industryCode.specialFoodServices': '特色餐饮服务',
    'legalEntity.industryCode.fullServiceRestaurants': '全服务餐厅',
    'legalEntity.industryCode.limitedServiceRestaurants': '有限服务餐厅（快餐）',
    'legalEntity.industryCode.cafeteriasGrillBuffets': '自助餐厅、烧烤及自助餐',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': '小吃及非酒精饮料吧',
    'legalEntity.industryCode.bakeries': '面包店',
    'billing.title': '我的账单空间',
    'billing.subtitle': '欢迎，此空间旨在简化发票管理。',
    'billing.description': '您可以在此按支付服务时间顺序查看发票，轻松查看最近付款、下载发票并一键查看发票历史记录。',
    'billing.information.edit': '修改账单信息',
    'billing.noIssuedInvoices': '暂无已开发票',
    'billing.table.creationDate': '创建日期',
    'billing.table.amount': '金额',
    'billing.table.status': '状态',
    'billing.table.service': '服务',
    'billing.table.invoiceNumber': '发票编号',
    'billing.table.invoiceName': '发票名称',
    'billing.table.dueDate': '到期日',
    'billing.table.downloadPDF': '下载 PDF',
    'billing.editConfiguration.selectEntityStep.title': '法律实体',
    'billing.editConfiguration.selectEntityStep.subtitle': '选择要修改账单信息的法律实体',
    'billing.editConfiguration.selectEntityStep.legalEntity': '法律实体',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': '请从列表中选择',
    'billing.editConfiguration.selectEntityStep.noLabel': '无名称的法律实体',
    'billing.editConfiguration.configureBillingStep.title': '账单信息',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': '收款人姓名',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': '与发票关联的电子邮件地址',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': '收款人地址',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': '补充信息',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': '邮政编码',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': '城市',
    'billing.editConfiguration.configureBillingStep.recipients': '发票收件人',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': '收件人电子邮件地址',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel': '将邮件地址 "{email}" 添加到收件人',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage': '创建或修改配置信息时发生错误',
    'billing.invoices.download': '下载',
    'billing.invoices.status.1': '待付款',
    'billing.invoices.status.2': '已付款',
    'billing.invoices.psp.4': 'Stripe',
    'billing.invoices.name.4': '统一 Stripe 发票',
    'reports.title': 'Adyen 报告',
    'reports.subtitle':
        '查看已转入您银行账户的交易，以及每笔转账的交易明细。此报告可帮助您对 Adyen E-Wallet 交易进行账务核对。',
    'reports.text': '生成一种或多种报告类型',
    'reports.choosePeriod': '选择时间段',
    'reports.chooseReport': '选择一种或多种报告类型',
    'reports.outgoingTransfers': '转账',
    'reports.reportType': '报告类型',
    'reports.error.missingDates': '请选择两个日期',
    'reports.error.missingReportType': '请选择报告',
    'reports.error.missingBrand': '当前用户没有关联的品牌',
    'pricingRevaluation.tableCard.title': '价格调整',
    'pricingRevaluation.tableCard.subtitle':
        '请输入所需的调整比率，选择是否应用于选项和附加项，然后选择需要调整的菜单并点击确认按钮。',
    'pricingRevaluation.input.placeholder': '调整比率',
    'consumptionMode.MODE_DELIVERY': '配送',
    'consumptionMode.MODE_TAKE_AWAY': '外带',
    'consumptionMode.MODE_SIT_IN': '堂食',
    'consumptionMode.MODE_DRIVE': '得来速',
    'paymentMethods.tableCard.title': '管理和配置',
    'paymentMethods.tableCard.subtitle': '您的支付方式',
    'paymentMethods.tab.pos': '收银台',
    'paymentMethods.tab.web': '在线订单',
    'paymentMethods.tab.kiosk': '自助终端',
    'paymentMethods.tab.kiosk.integration.title': '即时支付',
    'paymentMethods.tab.kiosk.integration.desc1': '自助终端上的银行卡支付需要餐厅拥有 Ingenico 账户。',
    'paymentMethods.tab.kiosk.integration.desc2': '如果您在自助终端上启用了身份验证，则可以使用其他即时支付方式。',
    'paymentMethods.tab.kiosk.payment.title': '取餐时支付',
    'paymentMethods.tab.kiosk.payment.desc': '告知用户餐厅柜台接受的支付方式。',
    'paymentMethods.tab.kiosk.payment': '支付',
    'paymentMethods.tab.kiosk.payment.accepted': '已接受',
    'paymentMethods.tab.kiosk.payment.refused': '已拒绝',
    'paymentMethods.consumptionMode': '选择消费模式',
    'paymentMethods.externalId': '外部代码',
    'configure.ingenico': '配置 Ingenico',
    'configure.nepting': '配置 Nepting',
    'configure.stripe': '配置 Stripe',
    'configure.edenred': '配置 Edenred',
    'configure.iopay': '配置 Adyen',
    'configure.paygreen': '配置 Paygreen',
    'configure.ewallet': '配置 E-Wallet',
    'configure.yavin': '配置 IOPay',
    'configure.yavin.neptingConfigured': '无法配置 IOPay，因为 Nepting 正在使用中。',
    'configure.nepting.yavinConfigured': '无法配置 Nepting，因为 IOPay 正在使用中。',
    'configure.stripe.iopayConfigured': '无法配置 Stripe，因为 Adyen 正在使用中。',
    'configure.iopay.stripeConfigured': '无法配置 Adyen，因为 Stripe 正在使用中。',
    'customer.form.modalDescription': '请填写必填信息 *',
    'customer.form.firstName': '名字 *',
    'customer.form.lastName': '姓氏 *',
    'customer.form.badgeNumber': '徽章编号 {index} *',
    'customer.form.badgeType': '徽章类型',
    'customer.form.badge.default': '设为主要',
    'customer.form.badgeType.placeholder': '请填写徽章类型',
    'customer.form.addBadge': '添加徽章',
    'customer.form.email': '邮箱地址 *',
    'customer.form.phoneNumber': '电话号码（可选）',
    'customer.form.arrivalDate': '到达日期（可选）',
    'customer.form.departureDate': '离开日期（可选）',
    'customer.form.password': '密码 *',
    'customer.form.confirmPassword': '确认密码 *',
    'customer.form.clientInfoSection': '用餐者基本信息',
    'customer.form.pricingRuleSection': '定价规则配置',
    'customer.form.accountPaymentTypeLabel': '客户账户类型 *',
    'customer.form.accountPaymentTypePlaceHolder': '请选择客户账户类型',
    'customer.form.guestGroupIdLabel': '分组 *',
    'customer.form.guestGroupIdPlaceHolder': '请选择分组',
    'customer.form.pricingRuleCodeLabel': '定价方案代码 *',
    'customer.form.pricingRuleCodePlaceHolder': '请选择定价方案',
    'customer.form.tariffCode': '价格代码（可选）',
    'customer.form.studentNumber': '用餐者编号（可选）',
    'customer.form.pricingRuleInfo': '您的定价方案代码未显示在列表中？请在此创建 ',
    'customer.form.groupInfo': '如需定义分组，请前往品牌 > 层级结构页面 ',
    'customer.form.sectionInfo': '如需定义部门，请前往品牌 > 层级结构页面 ',
    'customer.form.subSectionInfo': '如需定义子部门，请前往品牌 > 层级结构页面 ',
    'customer.form.here': '此处',
    'customer.form.section': '部门（可选）',
    'customer.form.subSection': '子部门（可选）',
    'customer.form.selectOptions.cash': '现付',
    'customer.form.selectOptions.prepayment': '预付款',
    'customer.form.selectOptions.postpayment_bankdebit': '后付款：工资扣款',
    'customer.form.selectOptions.postpayment_guest': '后付款：宾客',
    'brand.customers.action.import': '导入',
    'brand.customers.action.export': '导出',
    'brand.customers.page.title': '客户',
    'brand.customers.page.description': '您可以在此查看已注册到您品牌的完整客户列表。',
    'customer.modal.import.title': '导入客户',
    'customer.modal.import.firstPart': '将 {fileTemplate} 下载到您的电脑',
    'customer.modal.import.secondPart': '用您的客户数据填写文件',
    'customer.modal.import.thirdPart': '上传文件以导入您的客户',
    'customer.modal.import.report.title': '导入报告',
    'customer.modal.import.report.result': '结果',
    'customer.modal.import.report.success': '成功',
    'customer.modal.import.report.error': '错误',
    'customer.modal.import.report.message': '{created} 已创建，{updated} 已更新，{unchanged} 未更改',
    'customer.modal.import.warning':
        '注意！「价格代码」、「补贴代码」、「入场费代码」和「定价方案代码」列已弃用，导入时将被忽略。请使用定价方案表格配置这些信息。',
    'customer.modal.import.addNew.title': '添加新客户',
    'customer.modal.import.addNew.step1': '将 {link} 下载到您的电脑',
    'customer.modal.import.addNew.step1.link': '模板文件',
    'customer.modal.import.addNew.step2': '用您的新客户数据填写文件',
    'customer.modal.import.addNew.step3': '在下方上传已填写的文件',
    'customer.modal.import.update.title': '更新现有客户',
    'customer.modal.import.update.step1': '将 {link} 下载到您的电脑',
    'customer.modal.import.update.step1.link': '当前客户数据库',
    'customer.modal.import.update.step1.loading': '加载中...',
    'customer.modal.import.update.step2': '修改您要更新的客户数据',
    'customer.modal.import.update.step3': '在下方上传已修改的文件',
    'customer.modal.import.update.warning': '注意：客户标识符必须对应已有客户，才能执行更新。',
    'customer.modal.import.options.title': '导入选项',
    'customer.modal.import.options.multiBadge': '多徽章导入',
    'customer.modal.import.options.autoImportGuestHierarchy': '自动导入层级结构（分组、部门、子部门）',
    'customer.modal.import.error.noResponse': '导入失败 - 服务器无响应',
    'customer.modal.import.error.invalidResponse': '服务器响应无效',
    'customer.modal.import.error.fileTooLarge': '文件过大（最大 20 MB）',
    'customer.modal.import.loading.reading': '正在读取文件...',
    'customer.modal.import.loading.importing': '正在导入...',
    'customer.modal.import.result.lineError': '第 {lineNumber} 行{nameDisplay}：{error}',
    'customer.modal.import.result.fieldError': '字段（{fields}）未修改（第 {line} 行）',
    'customer.modal.import.result.genericError': '发生错误',
    'customer.modal.import.result.created': '已创建客户：{count}',
    'customer.modal.import.result.updated': '已更新客户：{count}',
    'customer.modal.import.result.unchanged': '未修改/未创建客户：{count}',
    'customer.modal.import.result.errors': '错误',
    'customer.modal.import.result.warnings': '警告',
    'customer.modal.import.result.otherWarning.PRICING_RULE': '系统中不存在以下定价规则：',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': '系统中不存在以下入场费：',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': '部分用餐者的分组为空（行：',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP': '部分用餐者分组不存在（行：',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE': '该分组不允许使用部分定价规则（行：',
    'customer.modal.import.result.restrictedFieldsInfo':
        '"密码"、"PIN 码"和"余额"字段只有在客户尚未进行任何交易时才能更新。',
    'customer.create.modalTitle': '创建新用餐者',
    'customer.update.modalTitle': '修改用餐者',
    'customer.tab.info': '信息',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': '集体餐饮',
    'customer.tab.orders': '订单历史',
    'route.customerPricingPolicy': '定价策略',
    'customer.pricingPolicy.defaultTitle': '默认策略',
    'customer.pricingPolicy.defaultDescription': '默认定价策略将应用于通过网络订购模块创建账户的所有客户。',
    'customer.pricingPolicy.customTitle': '自定义策略',
    'customer.pricingPolicy.entranceFee': '入场费',
    'customer.pricingPolicy.pricingPolicy': '定价方案',
    'customer.pricingPolicy.group': '分组',
    'customer.pricingPolicy.groupPlaceholder': '我的分组',
    'customer.pricingPolicy.domainName': '域名',
    'customer.pricingPolicy.delete': '删除',
    'customer.pricingPolicy.noEntranceFee': '无入场费',
    'customer.pricingPolicy.noPricingRule': '无定价规则',
    'customer.pricingPolicy.noGroup': '无分组',
    'customer.pricingPolicy.enableWhitelisting': '限制注册到已声明的域名',
    'customer.pricingPolicy.enableWhitelistingInfo': '启用此选项后，在线注册仅限于已声明的域名',
    'customer.pricingPolicy.save': '保存',
    'customer.student.info.title': '信息',
    'customer.student.info.desctiption': '集体餐饮模式相关信息。',
    'customer.student.info.account.type': '徽章类型',
    'customer.student.info.group': '分组',
    'customer.student.info.section': '部门',
    'customer.student.info.sub.section': '子部门',
    'customer.student.info.badge.number': '徽章编号',
    'customer.student.info.pricing.code': '价格代码',
    'customer.student.info.student.number': '用餐者编号',
    'customer.student.pricing.rules.title': '定价规则',
    'customer.student.pricing.rules.desctiption':
        '您可以为每位客户分配特定的定价规则。客户可以有补贴代码和/或入场费代码，或者定价方案代码（包含一组入场费和/或补贴）。',
    'customer.student.pricing.rules.deprecated':
        '⚠️ 入场费代码和补贴代码字段现已弃用，请改用定价方案代码字段（包含入场费和补贴）。{moreInfo}',
    'customer.student.pricing.rules.more_info': '更多信息',
    'customer.student.pricing.rules.grant.code': '补贴代码',
    'customer.student.pricing.rules.entrance.fee.code': '入场费代码',
    'customer.student.pricing.rules.code': '定价方案代码',
    'customer.student.overdraft.title': 'E-Wallet 允许透支',
    'customer.student.overdraft.desctiption': '您可以自定义客户使用 E-Wallet 时允许的最大透支金额。',
    'customer.student.overdraft.price.label': 'E-Wallet 允许透支',
    'customer.student.overdraft.disabled': '该客户适用默认的 E-Wallet 透支额度。',
    'customer.student.badge.title': '封锁用餐者主徽章',
    'customer.student.badge.description': '您可以临时封锁主徽章的使用。',
    'customer.student.badge.table.default': '主要',
    'customer.student.badge.table.number': '徽章编号',
    'customer.student.badge.table.type': '类型',
    'customer.student.badge.table.status': '状态',
    'customer.student.badge.table.action': '操作',
    'customer.student.badge.table.status.active': '✓ 已激活',
    'customer.student.badge.table.status.blocked': '✕ 已封锁',
    'customer.student.add.badge': '+ 添加徽章',
    'customer.student.badge.form.add': '添加徽章',
    'customer.student.badge.form.update': '编辑徽章',
    'customer.student.badge.form.default': '设为主要',
    'customer.ordersList.title': '订单',
    'customer.ordersList.subtitle': '查看您客户的订单',
    'customer.ordersList.downloadTickets': '下载票据',
    'customer.ordersList.exportStarted': '票据导出中，请稍候...',
    'customer.ordersList.exportSuccess': '票据导出成功！',
    'customer.ordersList.exportFailed': '票据导出失败，请重试。',
    'customer.ordersList.exportNoTicketsForDates': '所选日期无票据。',
    'customer.ordersList.downloadChoice.all': '所有票据',
    'customer.ordersList.downloadChoice.selectedRange': '仅限所选日期',
    'order.field.downloadTicket': '下载',
    'pricingRevaluation.options.exceeding': '应用于超额部分',
    'pricingRevaluation.options.options': '应用于选项',
    'pricingRevaluation.options.updateInPlace': '联网冰箱菜单/扫描托盘',
    'pricingRevaluation.options.updateInPlace.tooltip':
        '勾选此复选框时，调整将直接应用于原始菜单以保留 ID（将创建一份未调整的菜单副本）。\n取消勾选时，调整将应用于菜单副本（新 ID），原始菜单保持不变。',
    'pricingRevaluation.table.menu.name': '菜单名称',
    'pricingRevaluation.table.menu.isActive': '菜单已激活',
    'pricingRevaluation.table.menu.channels': '渠道',
    'pricingRevaluation.table.menu.selected': '已选择',
    'pricingRevaluation.table.emptyMessage': '此餐厅未找到菜单',
    'pricingRevaluation.table.search': '搜索菜单',
    'pos_layout.name': 'POS 触控布局',
    'pos_layout.page.title': 'POS 触控布局',
    'pos_layout.page.description': '整理您的触控布局，然后将其部署到关联的 POS 设备上。',
    'pos_layout.sort': '重新排序',
    'pos_layout.sort.random': '随机',
    'pos_layout.sort.by_name': '按名称',
    'pos_layout.sort.by_price': '按价格',
    'pos_layout.tabletSize': '平板尺寸',
    'pos_layout.inches': '英寸',
    'pos_layout.publishDescription': '您确定要保存并将菜单和触控布局发布到关联的 POS 设备吗？',
    'pos_layout.assignPos': '关联 POS 设备',
    'pos_layout.modal.warning': '注意',
    'pos_layout.modal.publish.description':
        '以下触控布局分类没有关联任何产品：\n• {categories} \n您确定要发布此触控布局吗？',
    'pos_layout.modal.save.description':
        '以下触控布局分类没有关联任何产品：\n• {categories} \n您确定要保存此触控布局吗？',
    'pos_layout.customPrice': '自由价格',
    'pos_layout.functions.create.title': '添加功能键',
    'pos_layout.functions.edit.title': '修改功能键',
    'pos_layout.functions.type': '键类型',
    'pos_layout.functions.type.placeholder': '选择类型',
    'pos_layout.functions.type.webview': '网页链接 / URL',
    'pos_layout.functions.name': '键名称',
    'pos_layout.functions.url': '目标网页链接/URL',
    'pos_layout.functions.submit': '保存',
    'pos_layout.functions.verifyLink': '验证链接',
    'pos_layout.functions.widthPercent': '宽度',
    'pos_layout.functions.heightPercent': '高度',
    'pos_device.role.independent': '独立',
    'pos_device.role.master': '主机',
    'pos_device.role.slave': '从机',
    'pos_device.role.independent.plural': '独立设备',
    'pos_device.role.master.plural': '主机设备',
    'pos_device.role.slave.plural': '从机设备',
    'action.action': '操作',
    'action.edit': '编辑',
    'action.duplicate': '复制',
    'action.copy': '拷贝',
    'action.export': '导出',
    'action.publish': '发布',
    'action.delete': '删除',
    'action.hide': '隐藏',
    'customers.page.title': '客户',
    'customers.page.description': '查看您的客户',
    'customers.id': 'ID',
    'customers.name': '客户',
    'customers.email': '电子邮件',
    'customers.phone': '电话号码',
    'customers.totalSpentAmount': '总消费额',
    'customers.orderCount': '订单数量',
    'customers.averageCart': '平均购物篮',
    'customers.lastOrder': '最后订单',
    'customers.frequency': '频率',
    'customers.status': '状态',
    'customers.ewalletBalance': 'E-Wallet 余额',
    'customers.archivedAt': '归档日期',
    'customers.disabledAt': '停用日期',
    'customers.showArchivedCustomers': '显示已归档客户',
    'customers.showDisabledCustomers': '显示已停用客户',
    'customers.options': '选项',
    'customers.domainNames': '域名',
    'customers.selectDomainNames': '选择域名',
    'customers.groups': '分组',
    'customers.selectGroups': '选择分组',
    'menu.name': '菜单名称',
    'menu.categories': '分类',
    'menu.products': '产品',
    'menu.functions': '功能',
    'menu.page.title': '菜单',
    'menu.page.description': '创建和管理您的菜单',
    'menu.table.associatedChannels': '关联渠道',
    'menu.action.newMenu': '+ 新建菜单',
    'menu.action.manualImportCrous': '强制导入 Crous',
    'menu.action.seeOperations': '查看操作',
    'menu.action.changeColor': '更改颜色',
    'menu.action.editProduct': '编辑产品',
    'menu.action.editCategory': '编辑分类',
    'menu.action.editFunction': '编辑功能',
    'menu.action.import': '导入菜单',
    'menu.action.noImport': '我不希望导入文件',
    'menu.modal.manualImportCrous.title': '手动导入 CROUS 目录',
    'menu.modal.manualImportCrous.description': '您确定要为该餐厅手动启动 CROUS 目录导入吗？',
    'menu.action.aiMenuScan': 'AI 扫描（测试版）',
    'menu.modal.aiMenuScan.title': '扫描您的新菜单（测试版）',
    'menu.modal.aiMenuScan.description.part1': '以 PDF 或图片格式导入您的新菜单',
    'menu.modal.aiMenuScan.description.part2': '点击生成 Excel 菜单',
    'menu.modal.aiMenuScan.description.part3': '自动下载含有可用信息的新菜单 Excel 文件',
    'menu.modal.aiMenuScan.action.cancel': '取消',
    'menu.modal.aiMenuScan.action.generate': '生成 Excel 菜单',
    'menu.modal.bannersDeactivated': '{count, plural, one {# 个促销横幅已被停用} other {# 个促销横幅已被停用}}',
    'menu.modal.create.importMenu': '导入菜单',
    'menu.modal.create.createMenu': '创建菜单',
    'menu.modal.error.wrongName': '请填写有效名称',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': '收银机',
    'menu.modal.create.import.excel.title': '添加新菜单',
    'menu.modal.create.import.excel.description.firstPart': '将 {fileTemplate} 下载到您的电脑',
    'menu.modal.create.import.excel.description.secondPart': '在模板文件中填写构成新菜单的产品信息',
    'menu.modal.create.import.excel.description.thirdPart': '点击下方按钮导入您的新文件',
    'menu.modal.create.import.pos.title': '导入现有菜单',
    'menu.modal.create.import.pos.description.firstPart': '选择您希望导入菜单的 innovorder 收银机',
    'menu.modal.create.import.json.title': '导入现有菜单',
    'menu.modal.create.import.json.description.firstPart': '请确认您的文件为 JSON 格式',
    'menu.modal.create.import.json.description.secondPart': '点击下方按钮导入您的新文件',
    'menu.modal.duplicate.title': '复制菜单',
    'menu.modal.delete.title': '删除菜单',
    'menu.modal.delete.description': '您确定要删除菜单："{menuName}" 吗？',
    'menu.modal.copy.title': '拷贝菜单',
    'menu.modal.publish.title': '发布菜单',
    'menu.modal.publish.autoPublish': '验证后重新加载自助终端',
    'menu.modal.publish.devicePublish': '在以下 POS 设备上发布菜单：',
    'menu.modal.publish.deliverooPublish': '在以下 Deliveroo 品牌上发布菜单：',
    'menu.modal.publish.ubereatsPublish': '在以下 UberEats 品牌上发布菜单：',
    'menu.modal.publish.duplicateBarCode': '\n- 条形码 {barCode} 在以下产品中重复：{products}',
    'menu.modal.error.name': '请在指定字段中输入名称',
    'menu.modal.error.channels': '需要停用与关联收银机的同步选项',
    'menu.modal.menu.name': '菜单名称',
    'menu.modal.message.defaultIncompatibleDisclaimer': '您只能关联版本不低于 7.0 的主收银机或独立收银机',
    'menu.modal.message.versionIncompatibleDisclaimer': '您只能关联版本不低于 {values} 的收银机',
    'menu.modal.message.roleIncompatibleDisclaimer': '您不能关联 {values} 类型的收银机',
    'menu.modal.channels.shouldSyncPos': '与收银机同步',
    'menu.modal.channels.isSyncFromPosEnabled': '当关联收银机发生修改时更新菜单',
    'menu.modal.channels.selectActive': '在以下渠道激活菜单',
    'menu.modal.channels.associatedChannels': '关联渠道',
    'menu.modal.channels.pos.selectActive': '选择要关联到菜单的收银机',
    'menu.modal.channels.deliveroo.selectActive': '选择要关联到菜单的 Deliveroo 品牌',
    'menu.modal.channels.ubereats.selectActive': '选择要关联到菜单的 UberEats 品牌',
    'menu.modal.channels.pos.notFound': '未找到任何收银机。',
    'menu.modal.channels.associatePos': '关联收银机',
    'menu.modal.channels.associateDeliveroo': '关联 Deliveroo 品牌',
    'menu.modal.channels.associateUberEats': '关联 UberEats 品牌',
    'menu.modal.channels.editMenu': '编辑菜单',
    'menu.modal.channels.createMenu': '创建菜单',
    'menu.modal.channels.selectPos': '选择收银机',
    'menu.modal.channels.selectDeliveroo': '选择 Deliveroo 品牌',
    'menu.modal.channels.selectUberEats': '选择 UberEats 品牌',
    'menu.modal.externalId': '外部代码',
    'menu.modal.warn.shift.title': '危险操作',
    'menu.modal.warn.shift.text': '在服务期间编辑菜单可能会影响关联自助终端上的顾客体验。',
    'menu.modal.warn.shift.button': '确定',
    'menu.importPOS.cancel': '暂不',
    'menu.importPOS.title': '将收银机缺失菜单导入后台',
    'menu.importPOS.step1.title': '新功能：一键将收银机菜单添加到这里！',
    'menu.importPOS.step1.bullet.1': '更简单、更深入地管理触摸方案和菜单',
    'menu.importPOS.step1.bullet.2': '可提前准备触摸方案并一键激活',
    'menu.importPOS.step1.bullet.3': '可将同一菜单用于收银机、自助终端和在线点餐',
    'menu.importPOS.step1.info': '仅版本高于 7 且类别为独立或主收银机的设备，才可在后台管理其菜单',
    'menu.importPOS.step2.pos': '已导入后台的收银机',
    'menu.importPOS.step2.switch': '当关联收银机将来发生修改时更新菜单',
    'menu.importPOS.step3.title': '一切就绪！',
    'menu.importPOS.step3.subtitle': '您现在可以直接从后台管理收银机了！',
    'menu.importPOS.step3.link': '访问文档',
    'menu.importPOS.step3.info1': '点击您选择的菜单以查看和修改它',
    'menu.importPOS.step3.info2': '您可以复制菜单以准备下一张菜单，或针对每个菜单修改关联的收银机和其他消费模式',
    'menu.importPOS.step3.info3':
        '只要您不发布菜单，关联收银机上的菜单将保持不变。\n<strong>因此，您必须执行发布操作，才能将后台对菜单所做的更改更新到收银机上。</strong>\n这可以在菜单页面上每个菜单的选项中完成，也可以从触摸方案页面完成。',
    'menuoperation.page.title': '菜单操作',
    'menuoperation.page.description': '查看您餐厅的菜单操作',
    'menuoperation.type': '类型',
    'menuoperation.type.update': '更新',
    'menuoperation.type.publish': '发布',
    'menuoperation.type.propagation': '传播',
    'menuoperation.message.from': '来自',
    'menuoperation.message.from.brandMenu': '来自品牌菜单：',
    'menuoperation.message.to': '发往',
    'menuoperation.errorModal.title': '发布报告',
    'menuoperation.errorModal.message': '发布未能完成。',
    'menuoperation.errorModal.checklist.intro': '请在再次确认之前检查以下几点：',
    'menuoperation.errorModal.checklist.requiredFields': '产品的所有必填字段均已填写',
    'menuoperation.errorModal.checklist.requiredMenuImage': '菜单包含图片',
    'menuoperation.errorModal.checklist.noSubCategories': '菜单不包含子分类',
    'menuoperation.errorModal.checklist.imageFormats': '图片符合所需格式（320x320px 至 6000x6000px 之间）',
    'menuoperation.errorModal.checklist.syncSettings': '同步设置已正确配置',
    'menuoperation.errorModal.checklist.stepDepthLimit': '未超过步骤深度限制（Deliveroo 最多 2 层）。',
    'menuoperation.actions': '操作',
    'menuoperation.action.download': '上一版菜单',
    'menuoperation.action.download.before': '初始菜单',
    'menuoperation.action.download.after': '最终菜单',
    'menuoperation.download.error.title': '下载失败',
    'menuoperation.download.error': '无法下载已归档的菜单，请稍后重试。',
    'menu.tags.title': '标签',
    'menu.tags.table.name': '名称',
    'menu.tags.create.link': '创建新标签',
    'menu.tags.create.error.alreadyTaken': '该标签已存在',
    'menu.tags.edit.title': '编辑标签',
    'menu.tags.create.title': '创建标签',
    'menu.tags.form.color.label': '颜色',
    'menu.tags.delete.confirm': '您确定要删除 {count} 个标签吗？',
    'menu.functions.title': '功能',
    'menu.functions.subtitle': '添加、修改并为您的触摸方案分配功能',
    'menu.functions.table.name': '名称',
    'menu.functions.table.type': '类型',
    'menu.functions.table.status': '状态',
    'menu.functions.table.action': '操作',
    'menu.functions.status.active': '已启用',
    'menu.functions.status.inactive': '已停用',
    'menu.functions.noData': '暂无已创建的功能',
    'menu.functions.delete.confirm': '您确定要删除 {count} 个功能吗？',
    'menu.steps.title': '步骤',
    'menu.steps.add.title': '新建步骤',
    'menu.steps.duplicate': '复制',
    'menu.steps.convert': '转换',
    'menu.steps.delete.confirm': '您确定要删除 {count} 个步骤吗？',
    'menu.steps.convert.toCustomization.confirm': '转换后，需要配置个性化步骤的详细信息和选项，是否继续？',
    'menu.steps.convert.toCrossSelling.confirm':
        '转换步骤后，关于最小/最大选择数量和已激活选项的信息将不会保留，是否继续？',
    'menu.steps.bulkConvertError': '要进行批量转换，所有步骤必须属于同一类型（加购销售或个性化）',
    'menu.steps.column.name': '名称',
    'menu.steps.column.choices': '可选项',
    'menu.steps.column.min': '最小值',
    'menu.steps.column.max': '最大值',
    'menu.steps.column.stepRef': '参考',
    'menu.steps.column.parentsProducts': '父产品数量',
    'menu.steps.edit.title': '编辑步骤',
    'menu.steps.editCustomization.title': '编辑个性化步骤',
    'menu.steps.editCrossSelling.title': '编辑加购销售步骤',
    'menu.steps.createCustomization.title': '创建个性化',
    'menu.steps.createCrossSelling.title': '创建加购销售',
    'menu.steps.convert.title': '注意',
    'menu.steps.column.type': '类型',
    'menu.steps.typeName.1': '个性化',
    'menu.steps.typeName.2': '加购销售',
    'menu.steps.form.ticketLabel': '票据标签',
    'menu.steps.form.minChoice': '最小选择数',
    'menu.steps.form.maxChoice': '最大选择数',
    'menu.steps.form.stepRef': '参考',
    'menu.steps.form.maxChoice.error.greaterThanMin': '必须大于最小值',
    'menu.steps.form.isDescriptionDisplayEnabled': '显示描述',
    'menu.steps.form.options': '选项',
    'menu.steps.form.isExcessAllowed': '允许超出',
    'menu.steps.form.isGroupEnabled': '分组',
    'menu.steps.form.isImageDisplayEnabled': '显示图片',
    'menu.steps.form.isQuantitySelectionEnabled': '数量',
    'menu.steps.form.isWeightStrategyEnabled': '使用重量',
    'menu.steps.form.stepProduct': '选项列表',
    'menu.steps.form.stepProduct.add': '添加选项',
    'menu.steps.form.stepProduct.orderByName': '按名称排序',
    'menu.steps.form.stepProduct.orderByPrice': '按价格排序',
    'menu.steps.form.stepProduct.setForAllOption': '传播数值',
    'menu.steps.form.stepProduct.name': '名称',
    'menu.steps.form.stepProduct.price': '价格',
    'menu.steps.form.stepProduct.excessPrice': '超出价格',
    'menu.steps.form.stepProduct.weight': '单件重量',
    'menu.steps.form.stepProduct.group': '分组',
    'menu.steps.form.stepProduct.maxQuantity': '最大数量',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': '默认选中（POS）',
    'menu.steps.form.stepProduct.posMinProductQuantity': '最小数量（POS）',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': '默认数量（POS）',
    'menu.steps.form.stepProduct.displayPOSFields': '显示 POS 属性',
    'menu.steps.form.stepProduct.import': '导入',
    'menu.steps.form.stepProduct.importWithPrice': '含价格导入',
    'menu.steps.form.stepProduct.importWithoutPrice': '不含价格导入',
    'menu.steps.propagate.title': '传播步骤',
    'menu.categories.title': '分类',
    'menu.categories.subtitle': '编辑菜单分类',
    'menu.categories.addCategory': '创建分类',
    'menu.categories.noData': '菜单中暂无分类。',
    'menu.categories.addProduct': '添加产品',
    'menu.categories.createProduct': '创建产品',
    'menu.categories.deleteCategory': '删除',
    'menu.categories.removeProduct': '移除',
    'menu.categories.deleteCategory.confirm':
        '您确定要删除此分类吗？\n它将不再可用，其子项（产品和子分类）将变为孤立状态。',
    'menu.categories.create.title': '创建分类',
    'menu.categories.edit.title': '编辑分类',
    'menu.categories.products': '{productCount, plural, =0 {暂无产品} one {# 个产品} other {# 个产品}}',
    'menu.categories.create.error.alreadyTaken': '该分类已存在',
    'menu.products.title': '产品',
    'menu.products.table.image': '图片',
    'menu.products.table.name': '名称',
    'menu.products.table.categories': '分类',
    'menu.products.table.price': '价格',
    'menu.products.table.vat': '增值税',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': '标签',
    'menu.products.reload.kiosk': '重新加载',
    'menu.products.create.link': '创建产品',
    'menu.products.massEdit': '批量编辑',
    'menu.products.duplicate': '复制',
    'menu.products.copy': '传播',
    'menu.products.copy.title': '传播产品',
    'menu.products.copy.form.restaurants.title': '选择目标餐厅',
    'menu.products.copy.form.restaurants.label': '目的地',
    'menu.products.copy.form.restaurants.tooltip': '选择品牌中将接收产品及其步骤传播的餐厅。',
    'menu.products.copy.form.restaurants.tooltip.title': '选择目标餐厅',
    'menu.products.copy.form.restaurants.tooltip.example':
        '从品牌菜单中，您决定仅将布朗尼甜点传播到餐厅 A 和 B → 只有这些餐厅会获得此新产品。',
    'menu.products.copy.form.updateIgnoreAttributes.title': '传播时，我不希望覆盖以下属性：',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        '将品牌产品传播到已存在该产品的餐厅（单独存在或通过步骤存在）时，您可以选择保留该单独产品的某些属性：标签、父分类、图片、价格、增值税、名称和描述。',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title': '传播已有产品时保留某些属性',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        '单独产品 Cookie 已在餐厅中存在，有自定义图片和特定价格 → 如果您勾选"图片"和"价格"，即使从品牌传播后，这些值也将保留。\n\n👉 对于新产品，品牌的所有属性均会自动传播。',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products': '已存在于目标餐厅菜单中的产品',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps': '已存在于目标餐厅菜单中的步骤',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title': '传播已有步骤时保留某些属性',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        '将品牌步骤传播到已存在该步骤的餐厅时，您可以选择保留该步骤的某些属性：步骤中产品的价格、每个产品的最大数量（如果启用了数量选项）以及超出价格。',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        '在餐厅中，"选择甜点"步骤中 Cookie 售价 2 欧元，最大数量为 3。\n品牌在步骤中传播 Cookie 售价 1 欧元，最大数量为 1。\n→ 如果您保留"产品价格"和"最大数量"，餐厅将保留 Cookie 2 欧元和最大数量 3。\n\n👉 对于新步骤，品牌的所有属性均会自动传播。',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder': '传播时，我不希望覆盖以下属性',
    'menu.products.copy.form.attribute.price': '价格',
    'menu.products.copy.form.attribute.vat': '增值税',
    'menu.products.copy.form.attribute.name': '名称',
    'menu.products.copy.form.attribute.description': '描述',
    'menu.products.copy.form.attribute.categories': '父分类',
    'menu.products.copy.form.attribute.tags': '标签',
    'menu.products.copy.form.attribute.imageId': '图片',
    'menu.products.copy.form.attribute.exceedPrice': '超出价格',
    'menu.products.copy.form.attribute.maxProductQuantity': '最大数量',
    'menu.products.copy.form.publishAfterCopy.title': '传播时，我希望：',
    'menu.products.copy.form.publishAfterCopy.tooltip': '自动在关联收银机上发布菜单',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': '自动发布',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        '如果启用，菜单将自动发布到关联目标餐厅的所有收银机上。',
    'menu.products.copy.form.publishAfterCopy': '自动在关联收银机上发布菜单',
    'menu.products.copy.form.publishAfterCopy.disclaimer': '⚠️ 注意，需要在触摸方案上添加新传播的产品',
    'menu.products.copy.form.strategy.title': '目标菜单中已有步骤的传播策略',
    'menu.products.copy.form.strategy.tooltip': '餐厅中已有的步骤将被品牌菜单中配置的步骤替换（包括产品和价格）。',
    'menu.products.copy.form.strategy.tooltip.title': '策略：更新现有步骤',
    'menu.products.copy.form.strategy.tooltip.example':
        '餐厅 A 的"选择甜点"步骤包含法式吐司、水果、Cookie（2 欧元）。\n品牌传播 Cookie（1 欧元）、布朗尼（2 欧元）→ 餐厅 A 将拥有 Cookie（1 欧元）、布朗尼（2 欧元）。\n\n👉 单独产品 Cookie 已更新，单独产品布朗尼已创建，法式吐司已从步骤中移除。',
    'menu.products.copy.form.strategy.replace': '用从品牌菜单传播的步骤更新餐厅菜单中的现有步骤',
    'menu.products.copy.form.strategy.replace.tooltip.title': '策略：更新现有步骤',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        '餐厅中已有的步骤将被品牌菜单中配置的步骤替换（包括产品和价格）。',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        '餐厅 A 的"选择甜点"步骤包含法式吐司、水果、Cookie（2 欧元）。\n品牌传播 Cookie（1 欧元）、布朗尼（2 欧元）→ 餐厅 A 将拥有 Cookie（1 欧元）、布朗尼（2 欧元）。\n\n👉 单独产品 Cookie 已更新，单独产品布朗尼已创建，法式吐司已从步骤中移除。',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        '更新餐厅菜单中的现有步骤，并保留品牌菜单步骤中不存在的现有产品',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title': '策略：更新并保留现有产品',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        '餐厅步骤将使用品牌步骤进行更新，但品牌菜单中缺少的已有产品将被保留。',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        '餐厅 A 的"选择甜点"步骤包含法式吐司（1 欧元）、水果（2 欧元）、Cookie（2 欧元）。\n品牌传播 Cookie（1 欧元）、布朗尼（2 欧元）→ 餐厅 A 将拥有法式吐司（1 欧元）、水果（2 欧元）、Cookie（1 欧元）、布朗尼（2 欧元）。\n\n👉 单独产品 Cookie 已更新，单独产品布朗尼已创建，法式吐司保留在步骤中。',
    'menu.products.copy.form.strategy.keep_existing': '不修改目标菜单中已有的步骤',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': '策略：不修改现有步骤',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description': '传播时，餐厅中已有的步骤不会被修改。',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        '餐厅 A 的"选择甜点"步骤包含法式吐司（1 欧元）、水果（2 欧元）、Cookie（2 欧元）。\n品牌传播 Cookie（1 欧元）、布朗尼（2 欧元）→ 餐厅 A 保留法式吐司（1 欧元）、水果（2 欧元）、Cookie（2 欧元）。\n\n👉 单独产品 Cookie 已更新，单独产品布朗尼已创建。',
    'menu.products.copy.form.channel.title': '选择目标渠道',
    'menu.products.copy.form.channel.tooltip':
        '选择产品及其步骤传播将应用的渠道（例如：收银机、在线点餐 (CEL)、自助终端）。',
    'menu.products.copy.form.channel.tooltip.title': '选择目标渠道',
    'menu.products.copy.form.channel.tooltip.example':
        '您传播布朗尼甜点，但只选择自助终端 → 该产品将仅在所选餐厅的自助终端菜单上可见。',
    'menu.products.copy.form.channel.web': '在线或桌边点餐',
    'menu.products.copy.form.channel.kiosk': '自助终端',
    'menu.products.copy.form.channel.pos': '收银机',
    'menu.products.copy.form.channel.marketplace': '外卖平台（UberEats/Deliveroo）',
    'menu.products.copy.form.channel.null': '未关联',
    'menu.products.copy.form.other.strategies.title': '新产品的创建',
    'menu.products.copy.form.other.strategies.tooltip':
        '传播新产品时，品牌在步骤中传播 Cookie，售价 2 欧元，最大数量为 3。如果您保留"产品价格"和"最大数量"，餐厅将保留 Cookie 2 欧元和最大数量 3。→ 如果您保留"产品价格"和"最大数量"，餐厅将保留 Cookie 2 欧元和最大数量 3。',
    'menu.products.copy.form.other.strategies.tooltip.title': '新产品的创建',
    'menu.products.copy.form.other.strategies.tooltip.example':
        '传播新产品时，品牌在步骤中传播 Cookie，售价 2 欧元，最大数量为 3。如果您保留"产品价格"和"最大数量"，餐厅将保留 Cookie 2 欧元和最大数量 3。\n→ 如果您保留"产品价格"和"最大数量"，餐厅将保留 Cookie 2 欧元和最大数量 3。',
    'menu.products.copy.form.other.strategies.tags': '即时创建产品缺少的标签',
    'menu.products.copy.form.other.strategies.categories': '即时创建产品缺少的分类',
    'menu.products.copy.form.posMenus.title': '收银机的活跃菜单',
    'menu.products.copy.form.posMenus.description':
        '此表格仅显示有多个活跃收银机菜单的餐厅。如果只有一个活跃的收银机菜单，默认将在该菜单上进行传播。',
    'menu.products.copy.form.posMenus.tooltip': '选择您希望为每个餐厅传播产品的收银机菜单。',
    'menu.products.copy.form.posMenus.tooltip.title': '选择收银机菜单',
    'menu.products.copy.form.posMenus.tooltip.example':
        '如果某餐厅有多个收银机菜单，您可以选择传播到一个或多个特定菜单。',
    'menu.products.copy.form.posMenus.column.restaurant': '餐厅名称',
    'menu.products.copy.form.posMenus.column.menus': '活跃菜单',
    'menu.products.copy.form.posMenus.empty': '所选餐厅没有可用的收银机菜单',
    'menu.products.copy.form.posMenus.placeholder': '选择菜单...',
    'menu.products.copy.form.posMenus.warning': '⚠️ 注意，默认情况下，餐厅的所有活跃菜单都会被选中用于产品传播。',
    'menu.products.copy.form.marketplaceMenus.title': '外卖平台的活跃菜单',
    'menu.products.copy.form.marketplaceMenus.description':
        '此表格仅显示有多个活跃外卖平台菜单的餐厅。如果只有一个活跃的外卖平台菜单，默认将在该菜单上进行传播。',
    'menu.products.copy.form.marketplaceMenus.tooltip': '选择您希望为每个餐厅传播产品的外卖平台菜单。',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': '选择外卖平台菜单',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        '如果某餐厅有多个外卖平台菜单，您可以选择传播到一个或多个特定菜单。',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': '餐厅名称',
    'menu.products.copy.form.marketplaceMenus.column.menus': '活跃菜单',
    'menu.products.copy.form.marketplaceMenus.empty': '所选餐厅没有可用的外卖平台菜单',
    'menu.products.copy.form.marketplaceMenus.placeholder': '选择菜单...',
    'menu.products.copy.form.marketplaceMenus.warning':
        '⚠️ 注意，默认情况下，餐厅的所有活跃菜单都会被选中用于产品传播。',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': '传播时，我希望：',
    'menu.products.copy.form.publishAfterCopy.marketplace': '自动在关联外卖平台上发布菜单',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer': '菜单将发布到关联餐厅的外卖平台上。',
    'menu.products.copy.form.disclaimer':
        '⚠️ 注意，此产品将被复制到所有已选餐厅的所有菜单中。保存前，请检查名称、描述、图片、增值税、价格。',
    'menu.copy.validate.title': '验证待传播的产品/步骤',
    'menu.copy.validate.success': '所有待传播的产品/步骤均已配置 SKU/步骤参考',
    'menu.copy.validate.warning': '品牌菜单产品详情中未填写 SKU',
    'menu.copy.validate.error': '品牌菜单中存在重复 SKU 或未填写步骤参考',
    'menu.copy.validate.step.missing.identifier.detail': '步骤上未填写步骤参考',
    'menu.copy.validate.product.missing.identifier.detail': '产品上未填写 SKU',
    'menu.copy.validate.step.duplicate.identifier.detail': '步骤之间存在参考 <b>{identifier}</b> 冲突',
    'menu.copy.validate.product.duplicate.identifier.detail': '产品之间存在 SKU <b>{identifier}</b> 冲突',
    'menu.products.overwrite': '勾选左侧复选框以编辑字段',
    'menu.products.overwriteRelations': '勾选左侧复选框以全部替换而非添加元素',
    'menu.products.error.alreadyTaken': '该产品已存在',
    'menu.products.error.billingCodeRequired': '自动计费需要填写此字段',
    'menu.products.add.title': '添加产品',
    'menu.products.edit.title': '编辑产品',
    'menu.products.propagate.title': '传播产品',
    'menu.products.create.title': '创建产品',
    'menu.products.delete.confirm': '您确定要删除 {count} 个产品吗？',
    'menu.products.form.price': '含税价格',
    'menu.product.form.pricePerkg': '含税价格 / 千克',
    'menu.products.form.priceType': '价格类型',
    'menu.products.form.priceType.placeholder': '价格类型',
    'menu.products.form.priceType.fixed': '固定价格',
    'menu.products.form.priceType.customizablePrice': '自由定价产品',
    'menu.products.form.priceType.customizablePriceAndLabel': '自由定价和自由标签产品',
    'menu.products.form.measurementUnit': '计量单位',
    'menu.products.form.measurementUnit.placeholder': '计量单位',
    'menu.products.form.measurementUnit.unit': '单位',
    'menu.products.form.measurementUnit.kg': '千克',
    'menu.products.form.kg.channelRestriction': '按千克计价的产品不适用于自助终端渠道。',
    'menu.products.form.availability': '按渠道显示可用性',
    'menu.products.form.webAvailability': '网页',
    'menu.products.form.kioskAvailability': '自助终端',
    'menu.products.form.servingCount': '用餐人数',
    'menu.products.form.barCode': '条形码',
    'menu.products.form.ticketLabel': '生产标签',
    'menu.products.form.ticketLabel.checkbox': '使用与产品名称不同的生产标签',
    'menu.products.form.noVat': '产品不需缴纳增值税',
    'menu.products.form.vat': '默认增值税',
    'product.vatGroup': '增值税组',
    'product.vatGroup.withHint': '增值税组（堂食/外带/外送）',
    'product.selectVatGroup': '选择增值税组',
    'product.vatGroup.noOperationZone': '该餐厅未配置操作区域',
    'product.vatGroup.eatIn': '堂食',
    'product.vatGroup.takeAway': '外带',
    'product.vatGroup.delivery': '外送',
    'product.vatGroup.hint': '要按消费模式更改增值税，请修改"增值税组（堂食/外带/外送）"字段',
    'menu.products.form.image.placeholder': '图片',
    'menu.products.form.externalId': '外部代码',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': '选择 SKU',
    'menu.products.form.sku.noOption': '新 SKU 只能在品牌层级创建',
    'menu.products.form.createSku': '创建 SKU "{value}"',
    'menu.products.form.replaceSkuAll': '将 SKU "{currentSku}" 替换为 "{value}"（适用于所有具有相同 SKU 的产品）',
    'menu.products.form.replaceSkuThisProduct': '将 SKU "{currentSku}" 替换为 "{value}"（仅适用于此产品）',
    'menu.products.form.createTag': '创建标签 "{value}"',
    'menu.products.form.billingCode': '账单代码',
    'menu.products.form.purchasePrice': '合同价格',
    'menu.products.form.description': '描述',
    'menu.products.form.description.tooLong': '描述不得超过 1500 个字符',
    'menu.products.form.additionalInformation': '附加信息',
    'menu.products.form.section.options': '选项',
    'menu.products.form.section.quantity': '库存管理',
    'menu.products.form.section.externalData': '外部数据',
    'menu.products.form.currentQuantitySwitch': '为产品启用库存管理',
    'menu.products.form.defaultQuantitySwitch': '每日重置库存',
    'menu.products.form.currentQuantityInput': '库存数量',
    'menu.products.form.defaultQuantityInput': '每日开始数量',
    'menu.products.form.defaultQuantityHint': '每天凌晨 4 点至 5 点之间，数量将重置为默认值',
    'menu.products.form.isEligibleLuncheon': '符合餐饮券资格',
    'menu.products.form.isFinalProduct': '最终产品',
    'menu.products.form.subsidizable': '可补贴产品',
    'menu.products.form.admissible': '可准入产品',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants': '每次加入购物车时乘以准入费/补贴',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        '启用此选项后，如果将产品多次添加到购物车，或将带有相同选项的其他产品添加到购物车，订单中的准入费（及补贴）将被乘以相应倍数。乘法在定价规则中定义的每日限额和上限范围内进行。',
    'menu.products.form.excludedFromUrssaf': '不计入 urssaf 最低金额',
    'menu.products.form.section.pos': '收银机专属属性',
    'menu.products.form.minQuantity': '最小数量',
    'menu.products.form.alwaysAskForCustomization': '始终请求步骤',
    'menu.products.form.discountable': '允许对产品打折',
    'menu.products.form.isDeposit': '押金类产品',
    'menu.products.form.posPrice': '押金金额',
    'menu.products.form.vatSitIn': '堂食增值税',
    'menu.products.form.vatDelivery': '外送增值税',
    'menu.products.form.vatTakeAway': '外带增值税',
    'menu.products.form.section.kitchenOptions': '厨房屏幕选项',
    'menu.products.form.isMenu': '是菜单',
    'menu.products.form.is_customization': '是个性化',
    'menu.products.form.isProducible': '在摘要中显示',
    'menu.products.form.no_kitchen': '不在厨房屏幕中显示',
    'menu.products.form.section.consumptionMode': '按消费模式显示产品可用性',
    'menu.products.form.consumptionModeType.mode_sit_in': '堂食',
    'menu.products.form.consumptionModeType.mode_delivery': '外送',
    'menu.products.form.consumptionModeType.mode_take_away': '外带',
    'menu.products.form.consumptionModeType.mode_drive': '得来速',
    'menu.products.form.tags': '标签',
    'menu.products.form.tags.placeholder': '搜索要关联的标签',
    'menu.products.form.steps': '步骤',
    'menu.products.form.steps.page': '第 {pageNumber} 页',
    'menu.products.form.steps.addToNewPage': '添加到新页面',
    'menu.products.form.steps.addEachToNewPage': '将每个步骤添加到新页面',
    'menu.products.form.steps.addToPage': '要添加步骤的页面',
    'menu.products.form.steps.addEmptyPage': '添加页面',
    'menu.products.form.categories': '父分类',
    'menu.products.form.productType': '类型',
    'menu.products.form.productType.placeholder': '产品类型',
    'menu.products.form.productType.product': '产品',
    'menu.products.form.productType.deposit': '押金',
    'menu.products.form.categories.placeholder': '搜索父分类',
    'menu.products.form.externalReference': '外部参考',
    'menu.products.form.externalReference.placeholder': '参考名称',
    'menu.products.form.externalReference.name': '名称',
    'menu.products.form.externalReference.value': '值',
    'menu.products.form.machineCode': '产品 Nayax 机器代码',
    'menu.products.form.steps.add': '添加步骤',
    'menu.products.form.steps.addPage': '将步骤拖到此处以创建新页面',
    'menu.products.form.steps.column.name': '名称',
    'menu.products.form.steps.column.type': '类型',
    'menu.products.form.steps.column.choices': '可选项',
    'menu.products.form.steps.column.position': '页面',
    'menu.products.form.steps.column.subPosition': '位置',
    'menu.products.form.steps.column.min': '最小值',
    'menu.products.form.steps.column.max': '最大值',
    'menu.products.form.steps.column.parentsProducts': '父产品数量',
    'menu.products.form.steps.cross-selling.add': '添加加购销售',
    'menu.products.form.steps.customization.add': '添加个性化',
    'menu.products.form.steps.type.cross-selling': '加购销售',
    'menu.products.form.steps.type.customization': '个性化',
    'reportGenerationsHistory.title': '生成历史',
    'reportGenerationsHistory.subtitle': '您可以在此找到导出生成历史记录。',
    'reportGenerationsHistory.tableCard.title': '导出',
    'reportGenerationsHistory.tableCard.subtitle': '导出列表',
    'reportGenerationsHistory.tableCard.actionLabel': '刷新页面',
    'reportGenerationsHistory.emptyMessage': '您的生成历史为空',
    'reportGenerationsHistory.tableHeader.createdAt': '日期',
    'reportGenerationsHistory.tableHeader.fileName': '文件名',
    'reportGenerationsHistory.tableHeader.reportType': '状态',
    'reportGenerationsHistory.tableHeader.status': '进度',
    'reportGenerationsHistory.tableHeader.action': '下载',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': '预开票',
    'reportGenerationsHistory.tableRow.reportType.orders': '订单',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': '徽章动态',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': '财务摘要',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary': '按管理模式分类的财务摘要',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': '按客户分类的徽章余额',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        '按管理模式分类的财务摘要（不含税）',
    'reportGenerationsHistory.tableRow.reportType.ewallet': '电子钱包',
    'reportGenerationsHistory.tableRow.reportType.accounting': '会计',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': '月度销售报告',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': '已完成',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': '进行中',
    'reportGenerationsHistory.tableRow.generationStatus.failed': '失败',
    'reportGenerationsHistory.tableRow.action.download': '下载',
    'report.emptyMessage': '无结果',
    'report.title.monthly_sales_report': '月度销售报告',
    'report.selectDateRangeButton.text': '从 {startDate} 至 {endDate}',
    'report.calendarModal.dateRage.errorMessage': '您最多只能选择 {maxRangeInDays} 天',
    'report.calendarModal.title': '选择时间段',
    'report.calendarModal.submit': '确认',
    'report.filtersButton.text': '筛选',
    'report.filtersModal.title': '选择筛选条件',
    'report.filtersModal.submit': '筛选',
    'report.filtersModal.form.restaurantLabel': '餐厅',
    'report.filtersModal.form.devicesLabel': '收银机',
    'report.filtersModal.form.sourcesLabel': '点餐渠道',
    'report.filtersModal.form.tagsLabel': '标签',
    'report.filtersModal.form.consumptionModesLabel': '消费模式',
    'report.filtersModal.form.sellersLabel': '销售员',
    'report.filtersModal.form.vatsLabel': '增值税',
    'report.filtersModal.form.categoriesLabel': '分类',
    'report.filtersModal.form.loyaltyLabel': '仅显示用积分支付的订单',
    'report.filtersModal.form.only_parentsLabel': '显示父分类',
    'report.filtersModal.saveAs.placeholder': '另存为...',
    'report.filtersModal.saveAs.save': '保存并应用',
    'report.exportButton.text': '导出',
    'report.exportResultModal.title': 'CSV 导出',
    'report.exportResultModal.resultSuccess': '导出正在生成中',
    'report.exportResultModal.stayInPage': '留在本页',
    'report.exportResultModal.redirectToGenerationHistory': '查看进行中的导出',
    'report.exportResultModal.resultFail': 'A problem has occurred, please try again in a few moments',
    'report.savedFiltersDropdown.placeholder': '已保存的筛选条件',
    'report.savedFiltersDropdown.deleteModal.title': '注意',
    'report.savedFiltersDropdown.deleteModal.description': '您确定要删除吗？',
    'salesSummary.tableCard.title': '生成新导出',
    'salesSummary.tableCard.subtitle': '选择您的标准和筛选条件，然后点击"生成"。',
    'salesSummary.form.choosePeriod': '选择时间段',
    'salesSummary.form.reportType': '报告格式',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': '按管理模式分类的财务摘要',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax': '按管理模式分类的财务摘要（不含税）',
    'salesSummary.form.reportType.salesSummary': '财务摘要',
    'salesSummary.form.restaurants': '餐厅',
    'salesSummary.form.groups': '分组',
    'salesSummary.form.pricingRules': '定价规则',
    'salesSummary.form.accountedOrders': '已入账订单',
    'salesSummary.form.accountedOrders.all': '订单 + 对冲分录',
    'salesSummary.form.accountedOrders.ordersOnly': '订单',
    'salesSummary.form.accountedOrders.contraEntriesOnly': '对冲分录',
    'salesSummary.exportResultModal.title': '生成导出',
    'shift.default': '默认',
    'shift.allDays': '每天',
    'shift.period': '从 {start} 至 {end}',
    'shift.days.MON': '星期一',
    'shift.days.TUE': '星期二',
    'shift.days.WED': '星期三',
    'shift.days.THU': '星期四',
    'shift.days.FRI': '星期五',
    'shift.days.SAT': '星期六',
    'shift.days.SUN': '星期日',
    'shift.amount.required': '金额为必填项',
    'shift.amount.positive': '金额必须为正数',
    'shift.threshold.positive': '阈值必须为正数',
    'shift.ceiling.required': '百分比补贴为必填项',
    'shift.vat.required': '增值税为必填项',
    'shift.vat.positive': '增值税必须为正数',
    'brandHistory.tableCard.title': '历史记录',
    'brandHistory.tableCard.subtitle': '搜索对品牌执行的操作',
    'brandHistory.emptyMessage': '未找到历史记录',
    'brandHistory.searchPlaceholder': '在历史记录中搜索',
    'brandHistory.entityType': '实体类型',
    'brandHistory.entityType.GRANT': '补贴',
    'brandHistory.entityType.ENTRANCE_FEE': '准入费',
    'brandHistory.entityType.PRICING_RULE': '定价规则',
    'brandHistory.entityType.PRODUCT': '产品',
    'brandHistory.entityType.STEP': '步骤',
    'brandHistory.entityType.CATEGORY': '分类',
    'brandHistory.entityType.MENU': '菜单',
    'brandHistory.entityType.MODULE': '模块',
    'brandHistory.entityType.CUSTOMER': '客户',
    'brandHistory.entityType.CUSTOMERS_IMPORT': '导入客户',
    'brandHistory.entityType.CUSTOMERS_UPDATE': '修改客户',
    'brandHistory.entityType.USER': '用户',
    'brandHistory.entityType.CHANNEL': '渠道',
    'brandHistory.entityType.CONSUMPTION_MODE': '消费模式',
    'brandHistory.entityType.ORDER': '订单',
    'brandHistory.entityType.BRAND': '品牌',
    'brandHistory.entityType.RESTAURANT': '餐厅',
    'brandHistory.entityName': '实体名称',
    'brandHistory.restaurant': '餐厅',
    'brandHistory.user': '用户',
    'brandHistory.action': '操作',
    'brandHistory.eventDate': '日期',
    'brandHistory.action.create': '创建',
    'brandHistory.action.open': '开启',
    'brandHistory.action.activate': '激活',
    'brandHistory.action.duplicate': '复制',
    'brandHistory.action.delete': '删除',
    'brandHistory.action.close': '关闭',
    'brandHistory.action.deactivate': '停用',
    'brandHistory.action.cancel': '取消',
    'brandHistory.action.update': '修改',
    'brandHistory.action.import': '导入',
    'brandHistory.action.unknown': '未知',
    'brandHistory.modal.title': '已执行操作报告',
    'brandHistory.modal.actions': '操作报告',
    'brandHistory.modal.logs': '日志报告',
    'brandHistory.modal.informations': '关联信息',
    'brandHistory.modal.entityName': '实体名称',
    'brandHistory.modal.user': '用户：',
    'brandHistory.modal.date': '更改日期：',
    'brandHistory.modal.close': '关闭',
    'brandHistory.modal.empty': '这里什么也没有 😰',
    'crossSelling.name': '加购销售页面名称',
    'crossSelling.page.title': '加购销售',
    'crossSelling.page.description': '创建和管理您的加购销售页面',
    'crossSelling.action.newCrossSelling': '+ 新建加购销售页面',
    'crossSelling.modal.duplicate.title': '复制加购销售页面',
    'crossSelling.modal.create.title': '创建您的加购销售页面',
    'crossSelling.modal.delete.title': '删除加购销售页面',
    'crossSelling.modal.delete.description': '您确定要删除页面："{crossSellingName}" 吗？',
    'crossSelling.modal.error.name': '请在指定字段中输入名称',
    'crossSelling.modal.menu.name': '加购销售页面名称',
    'crossSelling.page.create.title': '创建加购销售页面',
    'crossSelling.page.update.title': '修改加购销售页面 "{crossSellingName}"',
    'crossSelling.page.create.description': '加购销售页面配置',
    'crossSelling.page.update.description': '加购销售页面配置',
    'crossSelling.products.image': '图片',
    'crossSelling.products.name': '名称',
    'crossSelling.products.price': '价格',
    'crossSelling.products.vat': '增值税',
    'crossSelling.products.tags': '标签',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': '菜单',
    'crossSelling.products.menuState': '菜单状态',
    'crossSelling.products.restaurantName': '餐厅',
    'crossSelling.products.add': '添加产品',
    'crossSelling.products.menuState.enabled': '已启用',
    'crossSelling.products.menuState.disabled': '已停用',
    'tableLayout.name': '桌位布局名称',
    'tableLayout.page.title': '桌位布局',
    'tableLayout.page.description': '创建和管理您的桌位布局',
    'tableLayout.table.associatedPos': '关联收银机',
    'tableLayout.action.newTableLayout': '+ 新建桌位布局',
    'tableLayout.modal.create.title': '创建桌位布局',
    'tableLayout.modal.edit.title': '修改桌位布局 "{tableLayoutName}"',
    'tableLayout.modal.delete.title': '删除桌位布局',
    'tableLayout.modal.delete.description': '您确定要删除桌位布局："{tableLayoutName}" 吗？',
    'tableLayout.modal.publish.title': '发布桌位布局',
    'tableLayout.modal.publish.description': '您确定要发布桌位布局："{tableLayoutName}" 吗？',
    'tableLayout.modal.error.name': '请在指定字段中输入名称',
    'room.name': '大厅名称',
    'room.page.title': '大厅',
    'room.page.description': '创建和管理您的大厅',
    'room.action.newRoom': '+ 新建大厅',
    'room.action.publish': '发布桌位布局',
    'room.modal.create.title': '创建大厅',
    'room.modal.edit.title': '修改大厅 "{roomName}"',
    'room.modal.view.title': '大厅 "{roomName}"',
    'room.modal.single': '添加桌位',
    'room.modal.single.placeholder': '主桌',
    'room.modal.multiple': '添加多个桌位',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': '整理桌位',
    'room.modal.delete.title': '删除大厅',
    'room.modal.delete.description': '您确定要删除大厅："{roomName}" 吗？',
    'room.modal.error.name': '请在指定字段中输入名称',
    'room.modal.error.new_table_name': '请输入桌位名称或编号',
    'room.modal.error.fill_start_and_end': '请输入起始值和结束值（结束值必须大于起始值）',
    'room.modal.error.max_count_table': '每个大厅最多只能有 {maxCount} 张桌子。',
    'pos.configuration': '配置',
    'pos.devices': '收银机',
    'pos.access': '角色和权限',
    'pos.access.users': '用户',
    'pos.access.roles': '角色',
    'pos.access.groups': '分组',
    'pos.users.page.title': '收银机操作员',
    'pos.roles.page.title': '收银机角色和权限',
    'pos.groups.page.title': '收银机访问分组',
    'pos.users.page.description': '收银机操作员用于定义可以与收银机交互的用户。',
    'pos.roles.page.description': '收银机角色用于为收银机用户定义权限组。',
    'pos.groups.page.description': '访问组管理用户及其与餐厅收银机的关联',
    'pos.users.action.newUser': '创建新操作员',
    'posUser.name.form.label': '操作员姓名',
    'posUser.name.form.placeholder': '收银操作员姓名',
    'posUser.pinCode.form.label': '操作员PIN码',
    'posUser.pinCode.form.placeholder': '收银操作员PIN码',
    'posUser.role.form.label': '操作员角色',
    'posGroup.name.form.label': '组名称',
    'posGroup.name.form.placeholder': '输入访问组名称',
    'posGroup.users.form.label': '操作员',
    'posGroup.users.form.placeholder': '选择关联的操作员',
    'posGroup.devices.form.label': '收银机',
    'posGroup.devices.form.placeholder': '选择关联的收银机',
    'posUser.create.form.title': '创建新收银操作员',
    'posGroup.create.form.title': '创建新访问组',
    'posGroup.edit.form.title': '编辑访问组',
    'posUser.edit.form.title': '编辑收银操作员：',
    'posUser.form.description': '请填写您的收银操作员信息。',
    'posGroup.form.description': '请填写您的收银访问组信息。',
    'posUser.form.creation': '创建收银操作员',
    'posUser.form.edit': '编辑收银操作员',
    'posUser.form.update': '编辑收银操作员',
    'posRole.form.title': '收银角色',
    'posRole.form.description': '您可以从此页面更新收银角色的权限',
    'posRole.form.creation': '创建收银角色',
    'posRole.form.update': '编辑收银角色',
    'posGroup.form.creation': '创建访问组',
    'posGroup.form.update': '编辑访问组',
    'posRole.form.rolePermissions': '角色权限',
    'posRole.form.name.title': '角色名称',
    'posRole.form.name.placeholder': '角色',
    'pos.groups.action.create': '创建新组',
    'permissions.permissions': '权限',
    'assiciated.devices': '关联的收银机',
    'assiciated.operators': '关联的操作员',
    'posRole.Operator': '操作员',
    'posRole.Manager': '经理',
    'posRole.Owner': '店主',
    'posRole.Auditor': '审计员',
    'posRole.Treasurer': '财务',
    'posRole.Support': '支持',
    'posRole.Trainer': '培训师',
    'posRole.InCharge': '负责人',
    'posRole.OperatorSupervisor': '操作员主管',
    'posRole.AssistantOperator': '助理操作员',
    'posRole.AssistantToTheRegionalManager': '区域经理助理',
    'posRole.CustomOperator1': '自定义操作员 1',
    'posRole.CustomOperator2': '自定义操作员 2',
    'posRole.CustomOperator3': '自定义操作员 3',
    'channels.page.title': '渠道列表',
    'channels.page.description': '订单渠道允许您提供在线订餐、自助终端点餐或忠诚度管理等功能。',
    'channels.installed': '已安装应用',
    'channels.button.configure': '配置',
    'channels.button.disable': '停用',
    'channels.button.enable': '启用',
    'channels.kiosk.name': '自助终端',
    'channels.kiosk.description': '以最佳方式重塑销售点体验。',
    'channels.web.name': '在线订餐',
    'channels.web.description': '从您自己的网站开辟新的销售渠道。',
    'channels.reception.name': '接待',
    'channels.reception.description': '专为您的网络和终端订单提供的专用界面。',
    'channels.pos.name': 'POS',
    'channels.pos.description': '简单易用且与您的环境集成的收银系统。',
    'channels.kds.name': 'Kitchen display',
    'channels.kds.description': '以完美的组织方式进一步提升您的厨房效率。',
    'channels.loyalty.name': '忠诚度',
    'channels.loyalty.description': '培养客户忠诚度，让客户回到销售点消费。',
    'channels.ewallet_kiosk.name': 'E-Wallet充值终端',
    'channels.ewallet_kiosk.description': '快速充值E-Wallet的全新渠道。',
    'channels.vending_machine.name': '自动售货机',
    'channels.vending_machine.description': '在咖啡机和饮料自动售货机上提供E-Wallet支付。',
    'accessFlags.CAN_ACCESS_BRAND_HISTORY': '可访问品牌历史记录页面',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': '可访问客户页面',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION': '可访问补贴与入场费选项卡',
    'accessFlags.CAN_ACCESS_IO_PAY': '可访问支付模块',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': '可归档客户',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': '可创建负金额订单',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE': '可创建使就餐者余额变为负数的订单',
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': '可为就餐者后付款充值E-Wallet',
    'accessFlags.CAN_EDIT_AREAS': '可编辑配送区域',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': '自动计费：可修改参考数据',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': '可编辑客户凭据',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': '可导出客户数据并为E-Wallet充值/扣款',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE': '可强制新客户编辑默认提供的凭据',
    'accessFlags.CAN_MANAGE_BO_USERS': '可管理后台用户',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT': '可管理品牌级别的授权透支额度',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': '可管理客户级别的授权透支额度',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME': '仅可编辑关联产品和步骤的价格和名称',
    'accessFlags.CAN_SYNC_SALES': '可同步销售数据',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': '可修改桌位布局',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': '可创建自定义价格的订单',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS': '可为所有产品创建自定义价格的订单',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': '可创建或删除分类',
    'accessFlags.MENU_CATEGORY_EDIT': '可编辑分类',
    'accessFlags.MENU_CREATE_OR_DELETE': '可创建或删除菜单',
    'accessFlags.MENU_EDIT': '可编辑菜单',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': '可创建或删除产品',
    'accessFlags.MENU_PRODUCT_EDIT': '可编辑产品',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': '限制只能编辑产品价格',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': '仅阻止编辑产品价格',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': '可创建或删除步骤',
    'accessFlags.MENU_STEP_EDIT': '可编辑步骤',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': '可创建或删除标签',
    'accessFlags.MENU_TAG_EDIT': '可编辑标签',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': '可修改自己的密码',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': '可取消订单（反向记账）',
    'accessFlags.CAN_CREATE_SKU': '可创建SKU',
    'accessFlagsGroups.customers': '客户管理',
    'accessFlagsGroups.financial': '财务管理 / E-Wallet',
    'accessFlagsGroups.orders': '订单管理',
    'accessFlagsGroups.catalog': '目录管理',
    'accessFlagsGroups.subsidies': '补贴与入场费',
    'accessFlagsGroups.configuration': '餐厅配置',
    'accessFlagsGroups.administration': '管理与账户',
    'accessFlagsGroups.others': '其他权限',
    'accessFlagsSubsections.categories': '分类',
    'accessFlagsSubsections.menus': '菜单',
    'accessFlagsSubsections.products': '产品',
    'accessFlagsSubsections.steps': '步骤',
    'accessFlagsSubsections.tags': '标签',
    'accessFlagsControl.expandAll': '全部展开',
    'accessFlagsControl.collapseAll': '全部折叠',
    'accessFlagsControl.permission': '权限',
    'accessFlagsControl.permissions': '权限',
    'userRestaurants.noRestaurants': '暂无可用餐厅',
    'brandUsers.email': '邮箱',
    'brandUsers.lastConnection': '最后登录',
    'brandUsers.login': '登录',
    'brandUsers.loginAs': '以此身份登录',
    'brandUsers.loginAsBrandGroup': '多品牌账户（不可登录）',
    'brandUsers.newUser': '+ 新建用户',
    'brandRestaurants.newRestaurant': '+ 新建餐厅',
    'brandRestaurants.create.restaurantInfo': '餐厅信息',
    'brandRestaurants.create.restaurantName': '餐厅名称',
    'brandRestaurants.create.phone': '电话号码',
    'brandRestaurants.create.address': '地址',
    'brandRestaurants.create.locale': '语言',
    'brandRestaurants.create.currency': '货币',
    'brandRestaurants.create.operationZone': '运营区域',
    'brandRestaurants.create.operationZone.skip': '跳过 - 稍后配置',
    'brandRestaurants.create.operationZoneConfigure': '运营区域配置',
    'brandRestaurants.create.operationZone.selectProvider': '选择合规模式',
    'brandRestaurants.create.operationZone.currencyMismatch':
        '此区域使用与品牌不同的货币。需要新建品牌才能在此货币下运营。',
    'brandRestaurants.create.manager': '管理员',
    'brandRestaurants.create.selectExistingUser': '选择现有用户',
    'brandRestaurants.create.createNewUser': '创建新用户',
    'brandRestaurants.create.skipManager': '跳过此步骤',
    'brandRestaurants.create.letUserChoosePassword': '让用户自行设置密码',
    'brandRestaurants.create.done.title': '完成！',
    'brandRestaurants.create.done.message': '您已准备好配置 {name}',
    'brandRestaurants.create.done.configure': '配置',
    'user.create.title': '创建新用户',
    'user.create.firstName': '名字',
    'user.create.lastName': '姓氏',
    'user.create.phone': '电话号码',
    'user.create.email': '邮箱',
    'user.create.password': '密码',
    'user.create.confirmPassword': '确认密码',
    'user.create.letUserChoosePassword': '让用户自行设置密码',
    'user.create.error.phone.length': '电话号码必须包含10位数字。',
    'user.create.error.phone.valid': '此号码无效',
    'user.create.error.password.min': '密码无效（最少12个字符）',
    'user.create.error.passwordConfirm.sameAsPassword': '两次输入的密码必须相同',
    'brands.restaurantscount': '餐厅数量',
    'brands.favorite': '收藏',
    'brands.create': '+ 新建品牌',
    'brands.form.title': '创建新品牌',
    'brands.form.brandInfo': '品牌信息',
    'brands.form.brandInfo.title': '品牌名称',
    'brands.form.selectUser': '选择品牌负责人',
    'brands.form.selectUser.title': '创建品牌负责人',
    'brands.form.canals': '选择品牌的订单渠道',
    'brands.form.canals.title': '管理渠道',
    'brands.form.brandName': '名称',
    'brands.form.region': '地区与语言',
    'brands.form.currency': '货币',
    'brands.form.firstName': '名字 *',
    'brands.form.lastName': '姓氏 *',
    'brands.form.phoneNumber': '电话号码 *',
    'brands.form.email': '邮箱 *',
    'brands.form.password': '密码 *',
    'brands.form.confirmPassword': '确认密码 *',
    'brands.form.error.phone.valid': '此号码无效',
    'brands.form.error.password.min': '密码无效（最少12个字符）',
    'brands.form.error.passwordConfirm.sameAsPassword': '两次输入的密码必须相同',
    'posPermissions.accessPermissions': '访问权限',
    'posPermissions.otherPermissions': '其他权限',
    'posPermissions.ACCESS_CATALOG_SCREEN': '目录',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': '客户',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': '选项',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': '备用金',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': '促销',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': '配送员',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': '桌位布局',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': '新建订单',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': '订单跟踪',
    'posPermissions.ACCESS_PARAMETER_SCREEN': '参数设置',
    'posPermissions.ACCESS_PRINTER_SCREEN': '打印机',
    'posPermissions.ACCESS_RAZ_SCREEN': '报告',
    'posPermissions.ACCESS_TICKET_SCREEN': '票据',
    'posPermissions.ACCESS_USER_SCREEN': '用户',
    'posPermissions.APPLY_DISCOUNT': '应用促销',
    'posPermissions.CANCEL_ORDER': '取消订单',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': '取消订单中已确认的产品',
    'posPermissions.CREATE_GROUP': '创建组',
    'posPermissions.CREATE_PRODUCT': '创建产品',
    'posPermissions.DELETE_DEFAULT_PRINTER': '删除默认打印机',
    'posPermissions.DISCONNECT': '断开收银机连接',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': '下单时输入折扣',
    'posPermissions.EXPORT_ARCHIVE': '导出归档',
    'posPermissions.FORCE_ORDER_SHIFT': '强制订单服务班次',
    'posPermissions.GENERATE_ARCHIVE': '生成财务归档',
    'posPermissions.JUSTIFY_ORDERS': '为订单添加说明',
    'posPermissions.LINK_A_BADGE': '关联徽章',
    'posPermissions.MODIFY_FEATURE_OPTIONS': '修改选项',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': '长按修改功能',
    'posPermissions.MODIFY_GROUP_FROM_GRID': '长按修改组',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': '修改购物车中产品的价格',
    'posPermissions.MODIFY_PASSWORD': '修改密码',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': '显示产品详情',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE': '修改产品代码、计费和计费价格',
    'posPermissions.MODIFY_PRODUCT_PRICE': '在产品详情中修改价格',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': '在产品详情中修改其他属性',
    'posPermissions.MODIFY_TICKET': '修改票据',
    'posPermissions.MODIFY_TICKET_GROUPS': '修改票据组',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': '修改票据的订单类型',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': '修改票据的订单状态',
    'posPermissions.MODIFY_TICKET_QUANTITY': '修改票据数量',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': '修改订单中已确认的产品',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': '赠送产品',
    'posPermissions.OPEN_CASH_DRAWER': '打开钱箱',
    'posPermissions.PRINT_VALID_TICKET': '打印已确认的票据',
    'posPermissions.REFUND_CLIENT': '退款给客户',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': '从目录中删除产品',
    'posPermissions.REOPEN_ORDER': '重新打开订单',
    'posPermissions.SEARCH_CLIENT': '手动搜索客户',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': '在新通道屏幕上显示强制用餐按钮',
    'posPermissions.SYNC_ARCHIVE': '同步归档',
    'posPermissions.VIEW_AUDIT_TRAIL': '查看审计跟踪',
    'posPermissions.VIEW_FEATURE_OPTIONS': '查看选项',
    'posPermissions.VIEW_ORDER_AUDIT': '查看订单审计',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': '在报告中显示营业额',
    'posPermissions.VIEW_TICKET_AUDIT': '查看票据审计',
    'posPermissions.VIEW_TICKET_TEMPLATE': '查看票据模板',
    'posPermissions.MODIFY_TICKET_PRINTER': '修改票据打印机',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': '验证TPE支付操作',
    'multiBrand.user': '用户',
    'badgeReader.empty': '未配置任何徽章读取器',
    'badgeReader.notConfigured': '您似乎未配置徽章读取器。请前往我们的',
    'badgeReader.help': '帮助专区。',
    'badgeReader.create': '创建徽章读取器',
    'badgeReader.table.title': '徽章读取器',
    'badgeReader.table.name': '读取器名称',
    'badgeReader.table.deviceUuid': '读取器UUID',
    'badgeReader.table.driver': '读取器技术',
    'badgeReader.table.driverConfigs': '技术参数',
    'badgeReader.table.readingConditions': '读取规则',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': '条件 #{index}：',
    'badgeReader.readingCondition.stringLength': '• 如果长度 = {stringLength} 个字符',
    'badgeReader.readingCondition.convertBefore.none': '• 不进行转换',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• 转换为十进制 = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• 转换为ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• 转换为十六进制 = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• 删除零值',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• 反转字符',
    'badgeReader.readingCondition.convertBefore.prefix': '• 添加前缀字符 {prefix} 至 {substrLength} 个字符',
    'badgeReader.readingCondition.substrPositionStart': '• 从第 {substrPositionStart} 个字符开始读取',
    'badgeReader.readingCondition.substrLength': '• 读取 {substrLength} 个字符',
    'badgeReader.readingCondition.convertAfter.none': '• 不转换这 {substrLength} 个字符',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• 将这些十进制字符转换为 {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex': '• 将这些十六进制字符转换为 {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• 将这些ASCII字符转换为 {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• 删除零值',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• 反转这 {substrLength} 个字符',
    'badgeReader.delete.confirmation': '您确定要删除吗？',
    'badgeReader.delete.warning': '警告',
    'badgeReader.cancel.confirmation': '您确定要取消配置吗？',
    'badgeReader.cancel.warning': '警告',
    'badgeReader.driver.keyboard': '键盘输出',
    'badgeReader.driver.serial': '串行协议（RS232）',
    'badgeReader.driver.toqla': 'Toqla',
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    'badgeReader.convertion.none': '无转换',
    'badgeReader.convertion.hex-dec': '十六进制转十进制',
    'badgeReader.convertion.hex-ascii': '十六进制转ASCII',
    'badgeReader.convertion.dec-hex': '十进制转十六进制',
    'badgeReader.step.information': '创建读取器',
    'badgeReader.step.driverConfigs': '技术参数',
    'badgeReader.step.readingCondition': '读取规则',
    'badgeReader.form.name': '读取器名称',
    'badgeReader.form.deviceId': '读取器USB标识符',
    'badgeReader.form.deviceUuid': '读取器UUID',
    'badgeReader.form.driver': '读取器技术',
    'badgeReader.form.driverConfigBaudRate': 'Baudrate',
    'badgeReader.form.driverConfigDataBits': 'Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': '键盘布局',
    'badgeReader.form.readingCondition.order': '条件编号',
    'badgeReader.form.readingCondition.stringLength': '长度',
    'badgeReader.form.readingCondition.convertBefore': '读取前转换？',
    'badgeReader.form.readingCondition.substrPositionStart': '起始位置 / 前缀',
    'badgeReader.form.readingCondition.substrLength': '长度',
    'badgeReader.form.readingCondition.convertAfter': '读取后转换？',
    'badgeReader.step.readingCondition.add': '添加 +',
    'badgeReader.form.convertion.none': '已停用',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': '删除零值',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': '十六进制逐位反转',
    'badgeReader.form.convertion.prefix': '前缀',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',
    'posDevice.catalogHistory.title': '目录历史记录',
    'posDevice.catalogHistory.table.hash': '哈希值',
    'posDevice.catalogHistory.table.date': '创建日期',
    'posDevice.catalogHistory.table.actions': '操作',
    'posDevice.catalogHistory.button.download': '下载',
    'passwordUpdate.title': '更新密码',
    'passwordUpdate.currentPassword': '旧密码',
    'passwordUpdate.newPassword': '新密码',
    'passwordUpdate.confirmPassword': '确认新密码',
    'passwordUpdate.update': '保存',
    'passwordUpdate.passwordMismatch': '新密码与确认密码不匹配。',
    'passwordUpdate.passwordMinLength': '密码至少需要12个字符。',
    'passwordUpdate.success': '密码更新成功',
    'notification.guestHierarchy.title': '新功能',
    'notification.guestHierarchy.content': '账户层级设置正在更新。',
    'notification.guestHierarchy.link': '点击了解更多',
    'guestHierarchyTraining.page1.title': '欢迎使用客户路径管理',
    'guestHierarchyTraining.page1.content':
        '客户路径管理可对后台（BO）中的就餐者账户进行严格的参数配置。它基于<b>组 → 部门 → 子部门</b>的层级结构以及对这些元素的<b>价格方案</b>分配。这种结构化管理确保了优化一致的管理效果。',
    'guestHierarchyTraining.page2.title': '访问层级管理',
    'guestHierarchyTraining.page2.content':
        '打开新的<b>层级管理</b>选项卡。此空间可用于<b>创建和修改</b>组、部门和子部门。',
    'guestHierarchyTraining.page3.title': '创建或修改组',
    'guestHierarchyTraining.page3.content':
        '• 进入<b>层级管理 > 组。</b> {br}• 点击<b>「创建组」</b>或修改现有组。 {br}• 一个组拥有一个<b>唯一标签</b> (1) {br}• 为该组关联的就餐者定义<b>允许的价格方案</b> (2)',
    'guestHierarchyTraining.page4.title': '创建或修改部门',
    'guestHierarchyTraining.page4.content':
        '• 进入<b>层级管理 > 部门。</b> {br}• 点击<b>「创建部门」</b>或修改现有部门。 {br}• 将部门分配到<b>现有组</b>。(1) {br}• 需要唯一标签。(2) {br} • 为该部门关联的就餐者定义<b>允许的价格方案</b> (3)',
    'guestHierarchyTraining.page5.title': '创建或修改子部门',
    'guestHierarchyTraining.page5.content':
        '• 进入<b>层级管理 > 子部门。</b> {br}• 点击<b>「创建子部门」</b>或修改现有子部门。 {br}• 将子部门分配到<b>现有部门</b>。(1 和 2) {br}• 需要唯一标签。(3) {br} • 为该子部门关联的就餐者定义<b>允许的价格方案</b> (4)',
    'guestHierarchyInfo.title': '创建就餐者',
    'guestHierarchyInfo.content': '创建就餐者时，系统会根据所选的组、部门或子部门自动筛选可用的价格方案。',
    'loyalty.features.title': '已启用的功能',
    'loyalty.features.MultiRewardSelection': '多重奖励选择',
    'loyalty.features.Promocode': '促销码',
    'loyalty.features.Deals': '特惠活动',
    'loyalty.features.PointPayment': '积分支付',
    'splio.title': '集成 - Splio忠诚度',
    'splio.integrationEnabled': '集成已于 {date} 启用',
    'splio.description':
        '在以下字段中输入API密钥，将您的Splio计划与您的餐厅和Innovorder产品关联。\n此API密钥需从您的Splio界面获取。',
    'splio.apiKey.placeholder': '输入您的Splio API密钥',
    'splio.apiKey': 'Splio API密钥',
    'splio.programId': '忠诚度计划',
    'splio.allowCustomerRewardUsage': '允许客户使用奖励',
    'splio.formLink': '注册表单链接',
    'splio.optIn': '与营销简报关联的OptIn',
    'splio.memberIdentifier': '账户创建标识符',
    'splio.useCasualTone': '启用非正式称谓',
    'splio.authenticationMethods': '允许的忠诚度认证方式',
    'splio.registerMethods': '允许的忠诚度注册方式',
    'splio.methods.email': '电子邮件',
    'splio.methods.phone': '电话',
    'splio.methods.externalId': '忠诚度标识符',
    'splio.update.success': 'Splio集成更新成功',
    'splio.subscriptionToMarketingNewsletter': '订阅营销简报',
    'splio.subscriptionToLoyaltyNewsletter': '订阅忠诚度简报',
    'splio.deleteModal.title': '删除Splio集成',
    'splio.deleteModal.text': '您确定要删除Splio集成吗？',
    'splio.error.formLinkInvalid': '表单链接无效',
    'splio.error.changeProvider': '此餐厅已配置忠诚度集成，请先将其删除',
    'pickupPoint.page.title': '取餐点',
    'pickupPoint.page.description': '创建和管理您的取餐点',
    'pickupPoint.action.create': '创建取餐点',
    'pickupPoint.modal.createPickupPoint': '创建取餐点',
    'pickupPoint.modal.editPickupPoint': '修改取餐点',
    'pickupPoint.modal.deletePickupPoint': '删除取餐点',
    'pickupPoint.modal.delete.title': '删除取餐点',
    'pickupPoint.modal.delete.description': '您确定要删除取餐点「{name}」吗？',
    'pickupPoint.modal.pickupPoint.name': '名称',
    'pickupPoint.modal.pickupPoint.address': '地址',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': '补充地址信息',
    'pickupPoint.modal.pickupPoint.name.placeholder': '取餐点名称',
    'pickupPoint.modal.pickupPoint.address.placeholder': '取餐点地址',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': '取餐点补充地址信息',
    'pickupPoint.modal.warn.shift.title': '警告',
    'pickupPoint.modal.warn.shift.text':
        '请确保在删除此取餐点前没有进行中的订单。删除后，客户将无法看到此取餐点，进行中的订单将会丢失。',
    'pickupPoint.modal.warn.shift.button': '已了解',
    'como.title': '集成 - Como忠诚度',
    'como.description':
        '在以下字段中输入API密钥，将您的Como计划与您的餐厅和Innovorder产品关联。\n此API密钥需从您的Como界面获取。',
    'como.apiKey': 'Como API密钥',
    'como.integrationEnabled': '集成已于 {date} 启用',
    'como.apiKey.placeholder': '输入您的Como API密钥',
    'como.formLink': '注册表单链接',
    'como.useCasualTone': '启用非正式称谓',
    'como.authenticationMethods': '允许的忠诚度认证方式',
    'como.registerMethods': '允许的忠诚度注册方式',
    'como.methods.email': '电子邮件',
    'como.methods.phone': '电话',
    'como.methods.externalId': '忠诚度标识符',
    'como.error.formLinkInvalid': '表单链接无效',
    'como.update.success': 'Como集成更新成功',
    'como.deleteModal.title': '删除Como集成',
    'como.deleteModal.text': '您确定要删除Como集成吗？',
    'como.error.changeProvider': '此餐厅已配置忠诚度集成，请先将其删除',
    'como.error.invalidApiKey': '输入的API密钥无效。',
    'zerosix.title': '集成 - Zerosix忠诚度',
    'zerosix.description':
        '在以下字段中输入API密钥，将您的Zerosix计划与您的餐厅和Innovorder产品关联。\n此API密钥需从您的Zerosix界面获取。',
    'zerosix.apiKey': 'Zerosix API密钥',
    'zerosix.integrationEnabled': '集成已于 {date} 启用',
    'zerosix.apiKey.placeholder': '输入您的Zerosix API密钥',
    'zerosix.formLink': '注册表单链接',
    'zerosix.useCasualTone': '启用非正式称谓',
    'zerosix.authenticationMethods': '允许的忠诚度认证方式',
    'zerosix.registerMethods': '允许的忠诚度注册方式',
    'zerosix.methods.email': '电子邮件',
    'zerosix.methods.phone': '电话',
    'zerosix.methods.externalId': '忠诚度标识符',
    'zerosix.error.formLinkInvalid': '表单链接无效',
    'zerosix.update.success': 'Zerosix集成更新成功',
    'zerosix.deleteModal.title': '删除Zerosix集成',
    'zerosix.deleteModal.text': '您确定要删除Zerosix集成吗？',
    'zerosix.error.changeProvider': '此餐厅已配置忠诚度集成，请先将其删除',
    'zerosix.error.invalidApiKey': '输入的API密钥无效。',
    'restaurantInfo.title': '餐厅信息',
    'restaurantInfo.information.title': '关于餐厅',
    'restaurantInfo.name': '餐厅名称',
    'restaurantInfo.address': '餐厅地址',
    'restaurantInfo.contactName': '联系人姓名',
    'restaurantInfo.contactEmail': '电子邮件地址',
    'restaurantInfo.contactPhone': '电话号码',
    'restaurantInfo.externalId': '外部标识符',
    'restaurantInfo.tag': '餐厅标签',
    'restaurantInfo.families': '餐厅类别',
    'restaurantInfo.searchFamilies': '搜索类别',
    'restaurantInfo.image': '餐厅图片',
    'restaurantInfo.legal.title': '法律信息',
    'restaurantInfo.legal.description': '这些信息用于生成订单渠道的一般销售条款和法律声明',
    'restaurantInfo.legal.socialReason': '公司名称',
    'restaurantInfo.legal.organizationType': '组织类型',
    'restaurantInfo.legal.capital': '注册资本',
    'restaurantInfo.legal.commerceRegistryCity': '工商注册城市',
    'restaurantInfo.legal.siren': 'Siren编号',
    'restaurantInfo.legal.taxNumber': '增值税号',
    'restaurantInfo.legal.industryClassificationCode': 'NAF代码',
    'restaurantInfo.legal.publicationDirectorName': '出版负责人姓名',
    'restaurantInfo.legal.publicationDirectorFunction': '出版负责人职务',
    'restaurantInfo.legal.webmasterName': '网站管理员姓名',
    'restaurantInfo.legal.webmasterEmail': '网站管理员邮箱',
    'restaurantInfo.ewalletMinimum.title': '扫描托盘允许的最低E-Wallet余额配置',
    'restaurantInfo.ewalletMinimum.inputTitle': '最低金额',
    'restaurantInfo.ewalletMinimum.caseZero': '如不设置最低徽章限额，请在字段中输入0后保存。',
    'restaurantInfo.delete.title': '删除餐厅',
    'restaurantInfo.delete.description': '此餐厅创建于',
    'restaurantInfo.delete.button': '删除此餐厅',
    'restaurantInfo.save.error': '保存时发生错误，请重试。',
    'restaurantInfo.delete.error': '发生错误，请重新进行配置。',
    'restaurantInfo.delete.confirmTitle': '删除餐厅',
    'restaurantInfo.delete.confirmDescription': '您确定要删除此餐厅吗？此操作不可撤销。',
    'restaurantInfo.schedule.title': '允许的取餐时段',
    'restaurantInfo.schedule.manualEdit': '手动编辑',
    'restaurantInfo.schedule.autoEdit': '自动编辑',
    'restaurantInfo.schedule.autoEditDescription': '可快速创建时间段。',
    'restaurantInfo.schedule.description':
        '您可以为餐厅配置不同的允许取餐时段。这些时段对应餐厅的营业时间，客户可在此期间取回在线订购的商品。',
    'restaurantInfo.schedule.open': '营业',
    'restaurantInfo.schedule.closed': '休息',
    'restaurantInfo.schedule.day.mon': '周一',
    'restaurantInfo.schedule.day.tue': '周二',
    'restaurantInfo.schedule.day.wed': '周三',
    'restaurantInfo.schedule.day.thu': '周四',
    'restaurantInfo.schedule.day.fri': '周五',
    'restaurantInfo.schedule.day.sat': '周六',
    'restaurantInfo.schedule.day.sun': '周日',
    'restaurantInfo.schedule.mass.startHour': '开始时间',
    'restaurantInfo.schedule.mass.endHour': '结束时间',
    'restaurantInfo.schedule.mass.granularity': '间隔',
    'restaurantInfo.schedule.mass.15min': '15分钟',
    'restaurantInfo.schedule.mass.30min': '30分钟',
    'restaurantInfo.schedule.mass.1h': '1小时',
    'restaurantInfo.schedule.mass.overwrite': '覆盖现有时段',
    'restaurantInfo.schedule.mass.apply': '应用',
    'restaurantInfo.schedule.mass.noDays': '请至少选择一天。',
    'restaurantInfo.schedule.mass.midnight': '午夜',
    'order.customer.loyalty.anonymous': '匿名 {email}',
    'route.vatRatesMatrix': '增值税参考数据',
    'vatRatesMatrix.title': '全球增值税参考数据',
    'vatRatesMatrix.subtitle': '所有Innovorder产品税务的单一事实来源。修改将自动应用于新产品。',
    'vatRatesMatrix.vatGroup': '增值税类别',
    'vatRatesMatrix.codeLabel': '代码',
    'vatRatesMatrix.eatIn': '堂食',
    'vatRatesMatrix.takeAway': '外带',
    'vatRatesMatrix.delivery': '外卖',
    'vatRatesMatrix.exportCsv': '导出CSV',
    'vatRatesMatrix.exportError': 'CSV导出时发生错误，请重试。',
    'vatRatesMatrix.filterByZone': '按区域筛选',
    'vatRatesMatrix.filterByGroup': '按类别筛选',
    'vatRatesMatrix.filterByMode': '按模式筛选',
    'vatRatesMatrix.loading': '加载中...',
    'vatRatesMatrix.error': '加载数据时出错。',
    'vatRatesMatrix.family.FOOD': '食品',
    'vatRatesMatrix.family.NON_ALCOHOL': '无酒精',
    'vatRatesMatrix.family.ALCOHOL': '含酒精',
    'vatRatesMatrix.family.NORMAL': '普通',
    'vatRatesMatrix.family.NONE': '无',
    'route.promotionalBanners': '促销横幅',
    'promotionalBanner.page.title': '横幅管理',
    'promotionalBanner.page.subtitle': '创建和管理促销横幅，在您的终端上展示。',
    'promotionalBanner.page.emptyState': '创建促销横幅，在您的终端上推广您的产品和分类。',
    'promotionalBanner.page.emptyStateCta': '创建横幅',
    'promotionalBanner.page.noActiveMenu.title': '无活跃终端菜单',
    'promotionalBanner.page.noActiveMenu.desc': '👉 激活终端菜单以访问横幅配置。',
    'promotionalBanner.page.noActiveMenu.cta': '管理我的菜单',
    'promotionalBanner.action.create': '创建横幅',
    'promotionalBanner.action.edit': '编辑',
    'promotionalBanner.action.view': '查看',
    'promotionalBanner.action.delete': '删除',
    'promotionalBanner.action.activate': '激活',
    'promotionalBanner.action.deactivate': '停用',
    'promotionalBanner.table.listTitle': '促销横幅列表',
    'promotionalBanner.modal.createTitle': '创建横幅',
    'promotionalBanner.modal.editTitle': '编辑横幅',
    'promotionalBanner.modal.viewTitle': '查看横幅',
    'promotionalBanner.modal.close': '关闭',
    'promotionalBanner.modal.name': '名称',
    'promotionalBanner.modal.channel': '渠道',
    'promotionalBanner.modal.image': '图片',
    'promotionalBanner.modal.linkType': '链接类型',
    'promotionalBanner.modal.linkTarget': '目标',
    'promotionalBanner.modal.activateAndSave': '激活并保存',
    'promotionalBanner.modal.saveAsDraft': '保存为草稿',
    'promotionalBanner.modal.updateBanner': '更新横幅',
    'promotionalBanner.modal.deactivateBanner': '停用横幅',
    'promotionalBanner.modal.imageSizeError': '图片不得超过5MB',
    'promotionalBanner.modal.nameHelper': '此名称仅在后台可见。',
    'promotionalBanner.modal.nameLabel': '横幅名称',
    'promotionalBanner.modal.channelLabel': '目标渠道',
    'promotionalBanner.modal.channelKiosk': '自助终端',
    'promotionalBanner.modal.channelKioskDesc': '在终端订单流程开始时显示横幅。',
    'promotionalBanner.modal.channelWeb': 'CEL',
    'promotionalBanner.modal.channelWebDesc': '在在线订餐流程中显示。',
    'promotionalBanner.modal.channelWebDisabled': '即将推出。',
    'promotionalBanner.modal.imageLabel': '横幅图片',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · 最大5MB · 3:1格式',
    'promotionalBanner.modal.image.error.ratio': '格式必须为3:1',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': '链接类型',
    'promotionalBanner.modal.linkNone': '无链接',
    'promotionalBanner.modal.linkNoneDesc': '仅供展示，不可点击。',
    'promotionalBanner.modal.linkProduct': '产品',
    'promotionalBanner.modal.linkProductDesc': '点击后跳转至产品详情页。',
    'promotionalBanner.modal.linkCategory': '分类',
    'promotionalBanner.modal.linkCategoryDesc': '点击后跳转至该分类。',
    'promotionalBanner.modal.activateBanner': '激活横幅',
    'promotionalBanner.modal.replace': '替换',
    'promotionalBanner.modal.searchCategory': '搜索分类...',
    'promotionalBanner.modal.searchProduct': '通过名称或SKU搜索产品...',
    'promotionalBanner.table.name': '名称',
    'promotionalBanner.table.status': '状态',
    'promotionalBanner.table.source': '来源',
    'promotionalBanner.table.linkType': '链接类型',
    'promotionalBanner.table.actions': '操作',
    'promotionalBanner.table.sourceRestaurant': '餐厅',
    'promotionalBanner.table.sourceBrand': '品牌',
    'promotionalBanner.table.linkNone': '无链接',
    'promotionalBanner.table.linkCategory': '分类',
    'promotionalBanner.table.linkProduct': '产品',
    'promotionalBanner.table.statusActive': '活跃',
    'promotionalBanner.table.statusInactive': '未活跃',
    'promotionalBanner.table.linkDeleted': '已删除',
    'promotionalBanner.confirm.title': '当前有进行中的服务',
    'promotionalBanner.confirm.message': '此操作将重新加载所有终端并中断进行中的订单。',
    'promotionalBanner.confirm.confirm': '确认',
    'promotionalBanner.confirm.cancel': '取消',
    'promotionalBanner.delete.title': '删除横幅',
    'promotionalBanner.delete.description': '您确定要删除此横幅吗？',
    'promotionalBanner.confirm.message.bulk': '此操作将重新加载 {count} 家餐厅的终端并中断进行中的订单。',
    'promotionalBanner.action.duplicate': '复制',
    'promotionalBanner.duplicate.fallback.title': '已复制横幅（无链接）',
    'promotionalBanner.duplicate.fallback.product':
        '「{sourceName}」的副本已创建但无链接：在您的活跃终端菜单中未找到该SKU。',
    'promotionalBanner.duplicate.fallback.category':
        '「{sourceName}」的副本已创建但无链接：在您的活跃终端菜单中未找到该分类。',
    'promotionalBanner.duplicate.fallback.dismiss': '我知道了',
    'route.brand.promotionalBanners': '促销横幅',
    'brandPromotionalBanner.page.title': '品牌促销横幅',
    'brandPromotionalBanner.page.subtitle': '配置并将横幅推送至品牌旗下的餐厅。',
    'brandPromotionalBanner.page.empty': '暂无横幅。',
    'brandPromotionalBanner.action.create': '创建横幅',
    'brandPromotionalBanner.table.name': '名称',
    'brandPromotionalBanner.table.status': '状态',
    'brandPromotionalBanner.table.source': '来源',
    'brandPromotionalBanner.table.link': 'SKU或分类',
    'brandPromotionalBanner.table.activeRestaurants': '{count} 家活跃餐厅',
    'brandPromotionalBanner.table.actions': '操作',
    'brandPromotionalBanner.modal.createTitle': '创建品牌横幅',
    'brandPromotionalBanner.modal.editTitle': '编辑横幅',
    'brandPromotionalBanner.modal.name.label': '横幅名称',
    'brandPromotionalBanner.modal.image.label': '图片',
    'brandPromotionalBanner.modal.image.hint': '3:1格式，最大5MB',
    'brandPromotionalBanner.modal.image.error.ratio': '格式必须为3:1',
    'brandPromotionalBanner.modal.image.error.size': '图片超过5MB',
    'brandPromotionalBanner.modal.channel.label': '渠道',
    'brandPromotionalBanner.modal.channel.comingSoon': '即将推出',
    'brandPromotionalBanner.modal.link.label': '链接类型',
    'brandPromotionalBanner.modal.link.none': '无链接',
    'brandPromotionalBanner.modal.link.product': '产品（SKU）',
    'brandPromotionalBanner.modal.link.category': '分类',
    'brandPromotionalBanner.modal.link.product.hint':
        '如果在某家餐厅的活跃终端菜单中找不到该SKU，该横幅将在该餐厅显示为无链接。',
    'brandPromotionalBanner.modal.link.category.hint':
        '如果在某家餐厅的活跃终端菜单中找不到该分类，该横幅将在该餐厅显示为无链接。',
    'brandPromotionalBanner.modal.restaurants.label': '目标餐厅',
    'brandPromotionalBanner.modal.restaurants.empty': '请至少选择一家餐厅',
    'brandPromotionalBanner.modal.button.cancel': '取消',
    'brandPromotionalBanner.modal.button.saveDraft': '保存为草稿',
    'brandPromotionalBanner.modal.button.activate': '激活横幅',
    'brandPromotionalBanner.modal.button.deactivate': '停用横幅',
    'brandPromotionalBanner.modal.button.update': '更新横幅',
    'brandPromotionalBanner.delete.title': '删除横幅？',
    'brandPromotionalBanner.delete.message': '此横幅将从所有关联的餐厅中移除。',
    'brandPromotionalBanner.carousel.title': '两个横幅之间的显示间隔',
    'brandPromotionalBanner.carousel.description': '设置两个活跃横幅之间的显示时长。',
    'brandPromotionalBanner.carousel.helper': '两个活跃横幅之间的等待时间。',
    'brandPromotionalBanner.carousel.seconds': '秒',
    'brandPromotionalBanner.carousel.save': '保存',
    'brandPromotionalBanner.carousel.saved': '间隔已更新',
    'brandPromotionalBanner.carousel.help': '此间隔将在终端下次重新加载时应用于品牌旗下的所有餐厅。',
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel': '此餐厅未启用终端。',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': '此餐厅没有活跃的终端菜单。',
};

export default translationZhCn;
